<template>
    <div>
        <div class="dashboard-stats">
            <div class="stat-card" @click="applyQuickFilter('all')" title="Vezi toate oportunitățile">
                <div class="stat-icon" style="background: #dbeafe;">
                    <i class="dx-icon-box" style="color: #1e40af;"></i>
                </div>
                <div class="stat-content">
                    <div class="stat-label">Total Oportunități</div>
                    <div class="stat-value">{{ totalOpportunities }}</div>
                </div>
            </div>

            <div class="stat-card">
                <div class="stat-icon" style="background: #d1fae5;">
                    <i class="dx-icon-money" style="color: #065f46;"></i>
                </div>
                <div class="stat-content">
                    <div class="stat-label">Valoare Pipeline</div>
                    <div class="stat-value">{{ formatCurrency(totalPipelineValue) }}</div>
                </div>
            </div>

            <div class="stat-card" @click="applyQuickFilter('won')" title="Filtrează oportunități câștigate">
                <div class="stat-icon" style="background: #fef3c7;">
                    <i class="dx-icon-percent" style="color: #78350f;"></i>
                </div>
                <div class="stat-content">
                    <div class="stat-label">Oportunități Câștigate</div>
                    <div class="stat-value">{{ wonCount }}</div>
                </div>
            </div>

            <div class="stat-card" @click="applyQuickFilter('negotiation')" title="Filtrează oportunități în negociere">
                <div class="stat-icon" style="background: #fed7aa;">
                    <i class="dx-icon-chart" style="color: #92400e;"></i>
                </div>
                <div class="stat-content">
                    <div class="stat-label">În Negociere</div>
                    <div class="stat-value">{{ negotiationCount }}</div>
                </div>
            </div>
        </div>
        <DxDataGrid ref="dataGrid" :allowColumnReordering="true" :data-source="dsSales" :allowColumnResizing="true"
            key-expr="ID" :columnResizingMode="'nextColumn'" :show-borders="true" :syncLookupFilterValues="false"
            :filter-sync-enabled="true" :hover-state-enabled="true" :show-column-lines="false" :allowMerging="'Cells'"
            width="100%" @exporting="onExporting" @row-click="onRowClick" :remote-operations="true"
            class="grid theme-dependent" @content-ready="calculateStatistics" @option-changed="onOptionChanged"
            @row-removing="onRowRemoving" @row-removed="onRowRemoved" @row-prepared="onRowPrepared"
            @row-updated="onRowUpdated">
            <DxSelection mode="single" />
            <DxPaging :page-size="10" :page-index="0" />
            <DxPager :show-page-size-selector="true" :allowed-page-sizes="[5, 10, 20]" :show-info="true"
                :show-navigation-buttons="true" />
            <DxColumnChooser :enabled="true" :allow-search="true" title="Selector coloane" />
            <DxSorting mode="multiple" />
            <DxHeaderFilter :visible="true" />
            <DxLoadPanel :enabled="true" :indicator-src="'reload6.gif'" />
            <DxSearchPanel :visible="true" placeholder="Caută oportunitate..." />
            <DxExport :enabled="true" :allow-export-selected-data="false" :formats="['xlsx', 'pdf']" />
            <DxGridToolbar>
                <DxGridToolbarItem location="before">
                    <div class="toolbar-date-filter">
                        <span class="filter-label">Orizont:</span>
                        <DxDateBox v-model:value="startDate" type="date" display-format="dd/MM/yyyy"
                            @value-changed="applyGlobalFilter" width="130" placeholder="De la" />
                        <span class="filter-label" style="margin: 0 4px">-</span>
                        <DxDateBox v-model:value="endDate" type="date" display-format="dd/MM/yyyy"
                            @value-changed="applyGlobalFilter" width="130" placeholder="Până la" />
                        <DxButton icon="trash" styling-mode="text" hint="Resetează date" @click="resetFilters" />
                    </div>
                </DxGridToolbarItem>
                <!-- Quick Filters -->
                <!-- <DxGridToolbarItem location="before">
                    <div class="filter-buttons">

                        <DxButton text="Toate" :type="activeFilter === 'all' ? 'default' : 'normal'"
                            :styling-mode="activeFilter === 'all' ? 'contained' : 'outlined'"
                            @click="applyQuickFilter('all')" />


                        <DxButton v-for="status in statusList" :key="status.ID" :text="status.Nume"
                            :type="activeFilter === status.Nume ? 'default' : 'normal'"
                            :styling-mode="activeFilter === status.Nume ? 'contained' : 'outlined'"
                            @click="applyQuickFilter(status.Nume)" />
                    </div>
                </DxGridToolbarItem> -->
                <DxGridToolbarItem location="after">
                    <div class="separator"></div>
                </DxGridToolbarItem>
                <DxGridToolbarItem location="after" locate-in-menu="auto">
                    <div>
                        <dx-button icon="plus" type="success" @click="onAddClick" hint="Adauga Oportunitate" />
                    </div>
                </DxGridToolbarItem>
                <DxGridToolbarItem location="after" locate-in-menu="auto">
                    <div>
                        <DxButton icon="refresh" @click="onRefreshClick" hint="Reîmprospătează" />
                    </div>
                </DxGridToolbarItem>
                <DxGridToolbarItem location="after" locate-in-menu="auto">
                    <div>
                        <div class="separator"></div>
                    </div>
                </DxGridToolbarItem>
                <DxGridToolbarItem name="exportButton" hint="Exporta" />
                <DxGridToolbarItem location="after" locate-in-menu="auto">
                    <div>
                        <div class="separator"></div>
                    </div>
                </DxGridToolbarItem>
                <DxGridToolbarItem name="columnChooserButton" locate-in-menu="auto" hint="Alege Coloanele" />
                <DxGridToolbarItem name="searchPanel" locate-in-menu="auto" />
            </DxGridToolbar>
            <!-- <DxStateStoring :enabled="true" :filterValue="false" storage-key="CrmSales" /> -->
            <DxStateStoring :enabled="true" :filterValue="false" :savingTimeout="100"
                storage-key="gridOportunitatiState" />
            <DxFilterRow :visible="true" />
            <DxEditing :allow-deleting="true" :use-icons="true" mode="row" />

            <DxColumn data-field="Titlu" caption="Titlu Oportunitate" cell-template="titleTemplate" :allow-header-filtering="false" />
            <template #titleTemplate="{ data }">
                <div class="title-cell">
                    <i class="dx-icon-box"></i>
                    <span class="title-text">{{ data.value || '-' }}</span>
                </div>
            </template>

            <DxColumn data-field="Status.Nume" caption="Status" cell-template="statusTemplate" :allowFiltering="true"
                :allowSorting="true" :allow-header-filtering="true"
                :header-filter="{ dataSource: statusHeaderFilterDataSource }" />
            <template #statusTemplate="{ data }">
                <div class="status-cell">
                    <span :class="['status-badge', getStatusClass(data.value)]">
                        <span class="status-dot"></span>
                        {{ data.value || '-' }}
                    </span>
                </div>
            </template>

            <DxColumn data-field="Probabilitate" caption="Probabilitate Status" cell-template="probabilityTemplate" :allow-header-filtering="false" />

            <template #probabilityTemplate="{ data }">

                <div class="probability-cell" v-if="data.value !== null && data.value !== undefined">
                    <div class="probability-bar">
                        <div class="probability-fill" :style="{
                            width: data.value + '%',
                            backgroundColor: getProbabilityColor(data.value)
                        }"></div>
                    </div>
                    <span class="probability-text">{{ data.value }}%</span>
                </div>

                <span v-else class="probability-empty">-</span>
            </template>


            <DxColumn data-field="Contact/Nume" caption="Contact" cell-template="contactTemplate" :allow-header-filtering="false" />

            <DxColumn data-field="Contact/Prenume" caption="Prenume Contact" :visible="false" :allow-search="true" :allow-header-filtering="false" />




            <template #contactTemplate="{ data }">
                <div class="contact-cell" v-if="data.data.Contact">
                    <i class="dx-icon-user"></i>
                    <span>
                        {{ data.data.Contact.Nume }} {{ data.data.Contact.Prenume }}
                    </span>
                </div>
                <span v-else class="contact-empty">-</span>
            </template>



            <DxColumn data-field="Account.Nume" caption="Partener" cell-template="companyTemplate" :allow-header-filtering="false" />

            <template #companyTemplate="{ data }">
                <div class="company-cell" v-if="data.value">
                    <i class="dx-icon-home"></i>
                    <span>{{ data.value }}</span>
                </div>

                <span v-else>-</span>
            </template>


            <DxColumn data-field="Sursa.Nume" caption="Sursă Lead" :visible="false" :allow-header-filtering="false" />
            <!-- <DxColumn data-field="IntervalCumparare" caption="Interval Cumpărare" :width="160" /> -->

            <DxColumn data-field="BugetEstimat" caption="Buget Estimat" data-type="number" format="#,##0.00"
                cell-template="budgetTemplate" :allow-search="false" :calculate-cell-value="calculateBugetEUR" :allow-header-filtering="false" />

            <template #budgetTemplate="{ data }">
                <div class="currency-cell" v-if="data.value !== null && data.value !== undefined">
                    <span class="currency-value">{{ formatCurrency(data.value) }}</span>
                </div>
                <span v-else>-</span>
            </template>

            <DxColumn data-field="DataInchidereEstimat" caption="Închidere Estimată" data-type="date"
                format="dd/MM/yyyy" cell-template="closeDateTemplate" :allow-search="false" :allow-header-filtering="false" />

            <template #closeDateTemplate="{ data }">
                <div class="date-cell">
                    <i class="dx-icon-event"></i>
                    <span v-if="data.value">
                        {{ formatDate(data.value) }}
                    </span>
                    <span v-else class="date-empty">-</span>
                </div>
            </template>

            <DxColumn data-field="Owner" caption="Responsabil" :cell-template="'ownerCellTemplate'" :allow-header-filtering="false" />

            <template #ownerCellTemplate="{ data }">
                <div class="owner-cell">
                    <i class="dx-icon-user"></i>
                    <span>{{ data.displayValue || '-' }}</span>
                </div>
            </template>

            <DxColumn data-field="Note" caption="Note" :visible="false" :allow-header-filtering="false" />
            <DxColumn data-field="VenitRealizat" caption="Venit Realizat" :visible="false" data-type="number"
                :allow-search="false" :allow-header-filtering="false" />
            <DxColumn data-field="DataInchis" caption="Data Închidere" :visible="false" :allow-search="false" :allow-header-filtering="false" />
            <DxColumn data-field="UltimulStatus" caption="Ultimul Status" :visible="false" :allow-header-filtering="false" />
            <DxColumn data-field="MotivInchidere" caption="Motiv Închidere" :visible="false" :allow-header-filtering="false" />
            <DxColumn data-field="Campanie.Denumire" :visible="false" caption="Campanie Marketing" :allow-header-filtering="false" />
            <DxColumn data-field="CostEfectiv" caption="Cost Efectiv" :visible="false" data-type="number"
                :allow-search="false" :allow-header-filtering="false" />
            <DxColumn data-field="ListaProduse" caption="Produse" :visible="false" :allow-header-filtering="false" />
            <DxColumn data-field="Discount" caption="Discount" :visible="false" data-type="number" :allow-header-filtering="false" />
            <DxColumn data-field="Valuta.Simbol" :visible="false" caption="Valuta" :allow-header-filtering="false" />
            <DxColumn data-field="Curs" caption="Curs" :visible="false" :allow-header-filtering="false" />
            <DxColumn data-field="Proiect.Cod" caption="Proiect" :visible="false" :allow-header-filtering="false" />
            <DxColumn data-field="DataCreat" caption="Data Crearii" :visible="false" :allow-header-filtering="false" />

        </DxDataGrid>

        <!-- POPUP CU GRUPARE -->
        <DxPopupAdd :visible.sync="isModalVisible" :showTitle="true" :height="615" :width="1350">
            <template #title>
                <div class="popup-header">
                    <div class="popup-header-main">
                        <span class="popup-header-icon dx-icon-add"></span>
                        <div class="popup-header-texts">
                            <div class="popup-header-title">Adăugare oportunitate</div>
                            <div class="popup-header-subtitle">
                                Completează informațiile în pașii de mai jos
                            </div>
                        </div>
                    </div>
                    <div class="popup-header-meta">
                        <span class="status-chip status-chip--draft">
                            Nouă
                        </span>
                    </div>
                </div>
            </template>

            <div ref="popupBody" class="popup-body-simple popup-body-modern">

                <div class="form-content form-content-modern">
                    <DxForm :formData="formData" :col-count="2" :col-span="2">
                        <!-- TAB 1 -->
                        <DxFormItem item-type="group" :caption="tabs[0]" :col-count="2"
                            css-class="form-section-simple form-section-card">
                            <DxFormItem dataField="Titlu" css-class="field-full-width" :col-span="2">
                                <DxLabel text="Denumire Oportunitate" />
                                <DxRequiredRule message="Denumirea este obligatorie" />
                            </DxFormItem>


                            <DxFormItem :label="{ text: 'Status' }" :col-span="1">

                                <DxDropDownBox v-model:value="sStatus" :data-source="dsStatus" display-expr="Nume"
                                    value-expr="ID" :show-clear-button="true" placeholder="Nou"
                                    content-template="gridContent" :read-only="true">
                                    <template #gridContent>
                                        <div class="dropdown-grid-container" style="height: 300px;">
                                            <DxDataGrid :data-source="dsStatus" :hover-state-enabled="true"
                                                :height="280" :remote-operations="true" @row-click="onStatusRowClick">
                                                <DxPaging :enabled="true" :page-size="5" />
                                                <DxFilterRow :visible="true" />
                                                <DxScrolling mode="virtual" />
                                                <DxSorting mode="single" />

                                                <DxColumn data-field="NrOrd" :visible="false" sort-order="asc"
                                                    :sort-index="0" />

                                                <DxColumn data-field="Nume" caption="Status" />
                                                <DxColumn data-field="Pondere" caption="Pondere (%)" width="120" />
                                            </DxDataGrid>


                                        </div>
                                    </template>
                                </DxDropDownBox>
                            </DxFormItem>



                            <DxFormItem dataField="Owner" :editor-options="{ readOnly: true }" :col-span="1">
                                <DxLabel text="Responsabil" />
                            </DxFormItem>
                            <DxFormItem data-field="Data" editor-type="dxDateBox" :col-span="1" :editor-options="{
                                type: 'datetime',
                                displayFormat: 'dd/MM/yyyy',
                                dateSerializationFormat: 'yyyy-MM-ddTHH:mm:ssZ',
                                useMaskBehavior: true
                            }">
                                <DxLabel text="Data " />
                            </DxFormItem>

                            <DxFormItem :label="{ text: 'Partener' }" :col-span="2">
                                <DxRequiredRule message="Partenerul este obligatoriu" />
                                <DxDropDownBox v-model:value="sPartener" :data-source="dsParteneri" display-expr="Nume"
                                    value-expr="ID" :show-clear-button="true" placeholder="Selectează partener"
                                    content-template="gridContent" :drop-down-options="{ width: 500, height: 400 }">
                                    <template #gridContent>
                                        <div class="dropdown-grid-container" style="height: 300px;">
                                            <DxDataGrid :data-source="dsParteneri" :columns="['Nume']"
                                                :hover-state-enabled="true" :height="280" :remote-operations="true"
                                                @row-click="onPartenerRowClick">
                                                <DxScrolling mode="virtual" />
                                                <DxFilterRow :visible="true" />
                                                <DxPaging :enabled="true" :page-size="5" />
                                                <DxSearchPanel :visible="true" placeholder="Caută..." />

                                                <DxGridToolbar>
                                                    <DxGridToolbarItem location="after">
                                                        <DxButton icon="plus" type="success" height="25px" width="25px"
                                                            @click="onAddNewPartener" />
                                                    </DxGridToolbarItem>
                                                    <DxGridToolbarItem name="searchPanel" />
                                                </DxGridToolbar>
                                            </DxDataGrid>
                                        </div>
                                    </template>
                                </DxDropDownBox>
                            </DxFormItem>

                            <DxFormItem :label="{ text: 'Persoană de Contact' }">

                                <template #default>
                                    <DxRequiredRule message="Persoana de contact este obligatorie" />
                                    <DxDropDownBox v-model:opened="isContacteGridBoxOpened"
                                        :data-source="contactSelectat" v-model:value="sContact"
                                        :show-clear-button="true" display-expr="FullName" value-expr="ID"
                                        placeholder="Selectează contact" :disabled="!sPartener"
                                        :drop-down-options="{ width: 650, height: 400 }">

                                        <template #content="{ data }">
                                            <DxDataGrid :data-source="dsContacts"
                                                :selected-row-keys="sContact ? [sContact] : []"
                                                :hover-state-enabled="true" height="100%"
                                                @row-click="onContactRowClick">
                                                <DxSelection mode="single" />
                                                <DxScrolling mode="virtual" />
                                                <DxFilterRow :visible="true" />
                                                <DxSearchPanel :visible="true" placeholder="Caută..." />

                                                <DxColumn data-field="Nume" caption="Nume" />
                                                <DxColumn data-field="Prenume" caption="Prenume" />

                                                <DxGridToolbar>
                                                    <DxGridToolbarItem location="after">
                                                        <DxButton icon="plus" type="success" height="25px" width="25px"
                                                            @click="onAddNewContact" />
                                                    </DxGridToolbarItem>
                                                    <DxGridToolbarItem name="searchPanel" />
                                                </DxGridToolbar>
                                            </DxDataGrid>

                                        </template>
                                    </DxDropDownBox>
                                </template>
                            </DxFormItem>

                            <DxFormItem dataField="SursaID" :editorType="'dxSelectBox'" :editor-options="{
                                displayExpr: 'Nume',
                                valueExpr: 'ID',
                                dataSource: dsSalesSources,
                                placeholder: 'Selectează',
                                showClearButton: true
                            }">
                                <DxRequiredRule message="Sursa lead este obligatorie" />
                                <DxLabel text="Sursă Lead" />
                            </DxFormItem>



                        </DxFormItem>

                        <!-- TAB 4 -->
                        <DxFormItem item-type="group" :caption="tabs[3]" :col-span="3" :col-count="3"
                            css-class="form-section-simple form-section-card">

                            <DxFormItem dataField="BugetEstimat" editorType="dxNumberBox" :editor-options="{
                                format: '#0.00',
                                showSpinButtons: true
                            }" />
                            <DxFormItem dataField="ProbabilitateCastig" editorType="dxSelectBox" :editor-options="{
                                dataSource: probabilityList,
                                placeholder: 'Selectează %',
                                showClearButton: true
                            }">
                                <DxLabel text="Șansa de Câștig (%)" />
                            </DxFormItem>
                            <DxFormItem :label="{ text: 'Valută' }">
                                <template #default>
                                    <DxDropDownBox v-model:opened="isValutaGridBoxOpened" :data-source="valutaSelectat"
                                        v-model:value="sValuta" :show-clear-button="true" display-expr="Simbol"
                                        value-expr="Id" placeholder="RON">
                                        <template #content="{ data }">
                                            <DxDataGrid :data-source="dsValuta"
                                                :selected-row-keys="sValuta ? [sValuta] : []" :columns="['Simbol']"
                                                :hover-state-enabled="true" height="100%" @row-click="onValutaRowClick">
                                                <DxSelection mode="single" />
                                                <DxPaging :enabled="true" :page-size="5" />
                                                <DxFilterRow :visible="true" />
                                                <DxSearchPanel :visible="true" placeholder="Caută..." />
                                            </DxDataGrid>
                                        </template>
                                    </DxDropDownBox>
                                </template>
                            </DxFormItem>
                            <DxFormItem data-field="IntervalCumparare" editor-type="dxSelectBox" :editor-options="{
                                dataSource: intervalList,
                                valueExpr: 'name',
                                displayExpr: 'name',
                                searchEnabled: true,
                                placeholder: 'Necunoscut',
                                showClearButton: true
                            }">
                                <DxLabel text="Interval Cumpărare" />
                            </DxFormItem>
                            <DxFormItem dataField="DataInchidereEstimat" editorType="dxDateBox" :editor-options="{
                                displayFormat: 'dd/MM/yyyy',
                                dateSerializationFormat: 'yyyy-MM-ddTHH:mm:ssZ'
                            }" />

                            <DxFormItem :label="{ text: 'Campanie' }" :col-span="2">
                                <DxDropDownBox v-model:opened="isCampaniiGridBoxOpened" :data-source="campanieSelectat"
                                    v-model:value="sCampanie" :show-clear-button="true" display-expr="Denumire"
                                    value-expr="ID" placeholder="Selectează campanie"
                                    :drop-down-options="{ width: 450 }">
                                    <template #content="{ data }" style="height: 300px;">
                                        <DxDataGrid :data-source="dsCampaniiMarketing"
                                            :selected-row-keys="sCampanie ? [sCampanie] : []" :columns="['Denumire']"
                                            :hover-state-enabled="true" :height="300" @row-click="onCampanieRowClick">
                                            <DxSelection mode="single" />
                                            <DxScrolling mode="virtual" />
                                            <DxFilterRow :visible="true" />
                                            <DxSearchPanel :visible="true" placeholder="Cauta ..." />
                                        </DxDataGrid>
                                    </template>
                                </DxDropDownBox>
                            </DxFormItem>

                            <DxFormItem dataField="Note" editor-type="dxTextArea" :editor-options="{ height: 100 }"
                                :col-span="3">
                                <DxLabel text="Observații" />
                            </DxFormItem>
                        </DxFormItem>
                    </DxForm>
                </div>

                <div class="form-footer footer-fixed footer-modern">

                    <div class="footer-right">
                        <DxButton text="Salvează" type="success" width="120" height="32" styling-mode="outlined"
                            @click="onSaveAdd" />
                        <DxButton text="Închide" type="danger" width="120" height="32" styling-mode="outlined"
                            @click="onCancel" />
                    </div>
                </div>
            </div>
        </DxPopupAdd>

        <DxPopupAdd :visible="isPartnerModalVisible" :width="1450" :height="'90vh'" :max-height="800" :show-title="true"
            title="Adăugare Partener Nou" @hiding="isPartnerModalVisible = false">
            <template #title>
                <div class="popup-header">
                    <div class="popup-header-main">
                        <span class="popup-header-icon dx-icon-add"></span>
                        <div class="popup-header-texts">
                            <div class="popup-header-title">Adăugare partener</div>
                            <div class="popup-header-subtitle">
                                Completează detaliile partenerului
                            </div>
                        </div>
                    </div>
                    <div class="popup-header-meta">
                        <span class="status-chip status-chip--draft">
                            Nou
                        </span>
                    </div>
                </div>
            </template>
            <div class="popup-body-modern">
                <DxForm ref="newPartnerFormRef" :form-data="newPartnerData" :col-count="3" :col-span="3">

                    <DxFormItem item-type="group" caption="Identitate & Fiscal" :col-count="6"
                        css-class="form-section-simple form-section-card">
                        <DxFormItem data-field="CUI" :label="{ text: 'CUI/CNP' }" :editor-options="cuiOptions"
                            :col-span="3">
                            <DxRequiredRule message="Câmpul 'CUI/CNP' este obligatoriu" />
                        </DxFormItem>
                        <DxFormItem data-field="Nume" :col-span="3">
                            <DxRequiredRule message="Câmpul 'Nume' este obligatoriu" />
                        </DxFormItem>


                        <DxFormItem data-field="Fiscal" editor-type="dxSelectBox" :col-span="4"
                            :label="{ text: 'Tip Fiscal' }" :editor-options="{
                                dataSource: dsParteneriFiscal,
                                displayExpr: 'Nume',
                                valueExpr: 'Cod',
                                placeholder: 'Selectează Tip Fiscal',
                            }">
                            <DxRequiredRule message="Câmpul 'Tip Fiscal' este obligatoriu" />
                        </DxFormItem>
                        <DxFormItem data-field="Numar" :label="{ text: 'Regim Comerț' }" :col-span="2" />
                        <DxFormItem data-field="Caen" :label="{ text: 'Cod CAEN' }" :col-span="2" />

                        <DxFormItem data-field="Owner" :editor-options="{ readOnly: true }"
                            :label="{ text: 'Responsabil' }" :col-span="2" />
                        <DxFormItem data-field="Cont" :label="{ text: 'IBAN' }" :col-span="2" />

                        <DxFormItem :label="{ text: 'Grup *' }" :col-span="3">
                            <DxSelectBox v-model:value="newPartnerData.GrupID" :data-source="dsGrupuri"
                                display-expr="Nume" value-expr="Id" placeholder="Selectează grupul"
                                :search-enabled="true" :show-clear-button="true" />
                        </DxFormItem>
                        <DxFormItem :label="{ text: 'Zona *' }" :col-span="3">
                            <DxSelectBox v-model:value="newPartnerData.ZonaID" :data-source="dsZona"
                                display-expr="Nume" value-expr="Id" placeholder="Selectează zona"
                                :search-enabled="true" :show-clear-button="true" />
                        </DxFormItem>

                        <DxFormItem data-field="Memo" :col-span="6" :editor-options="{ height: 80 }"
                            editor-type="dxTextArea" />
                    </DxFormItem>

                    <DxFormItem item-type="group" caption="Sediu Social" :col-span="1" :col-count="4"
                        css-class="form-section-simple form-section-card">

                        <DxFormItem data-field="Strada" :col-span="3" />
                        <DxFormItem data-field="Numarstrada" :col-span="1" :label="{ text: 'Nr.' }" />

                        <DxFormItem data-field="Bloc" :col-span="1" />
                        <DxFormItem data-field="Scarabloc" :col-span="1" :label="{ text: 'Sc.' }" />
                        <DxFormItem data-field="Et" :col-span="1" :label="{ text: 'Etaj' }" />
                        <DxFormItem data-field="Ap" :col-span="1" :label="{ text: 'Ap.' }" />

                        <DxFormItem :label="{ text: 'Țara *' }" :col-span="2">
                            <DxSelectBox v-model:value="newPartnerData.TaraID" :data-source="dsPartnerTari"
                                display-expr="Nume" value-expr="ID" placeholder="Selectează țara"
                                :search-enabled="true" :show-clear-button="true" @value-changed="onTaraChanged" />
                        </DxFormItem>
                        <DxFormItem :label="{ text: 'Județ *' }" :col-span="2">
                            <DxSelectBox v-model:value="newPartnerData.JudetID" :data-source="dsPartnerJudete"
                                display-expr="Nume" value-expr="ID" placeholder="Selectează județul"
                                :search-enabled="true" :show-clear-button="true" @value-changed="onJudetChanged" />
                        </DxFormItem>

                        <DxFormItem data-field="Localitate" :col-span="3"
                            :editor-options="{ onValueChanged: onLocalitateChanged }">
                            <DxRequiredRule message="Câmpul 'Localitate' este obligatoriu" />
                        </DxFormItem>
                        <DxFormItem data-field="CP" :col-span="1" :label="{ text: 'C.P.' }" />

                        <DxFormItem data-field="Adresa" :col-span="4" editor-type="dxTextArea"
                            :editor-options="{ height: 80 }" :label="{ text: 'Adresă Completă' }" />
                    </DxFormItem>

                    <DxFormItem item-type="group" caption="Domiciliu Fiscal" :col-span="1" :col-count="4"
                        css-class="form-section-simple form-section-card">
                        <DxFormItem data-field="CStrada" :col-span="3" :label="{ text: 'Strada' }" />
                        <DxFormItem data-field="CNumarstrada" :col-span="1" :label="{ text: 'Nr.' }" />

                        <DxFormItem data-field="CBloc" :col-span="1" :label="{ text: 'Bl.' }" />
                        <DxFormItem data-field="CScarabloc" :col-span="1" :label="{ text: 'Sc.' }" />
                        <DxFormItem data-field="CEt" :col-span="1" :label="{ text: 'Etaj' }" />
                        <DxFormItem data-field="CAp" :col-span="1" :label="{ text: 'Ap.' }" />

                        <DxFormItem :label="{ text: 'Țara' }" :col-span="2">
                            <DxSelectBox v-model:value="newPartnerData.CTaraID" :data-source="dsCTari"
                                display-expr="Nume" value-expr="ID" placeholder="Selectează țara"
                                :search-enabled="true" :show-clear-button="true" @value-changed="onCTaraChanged" />
                        </DxFormItem>
                        <DxFormItem :label="{ text: 'Județ' }" :col-span="2">
                            <DxSelectBox v-model:value="newPartnerData.CJudetID" :data-source="dsCJudete"
                                display-expr="Nume" value-expr="ID" placeholder="Selectează județul"
                                :search-enabled="true" :show-clear-button="true" @value-changed="onCJudetChanged" />
                        </DxFormItem>

                        <DxFormItem data-field="CLocalitate" :col-span="3" :label="{ text: 'Localitate' }"
                            :editor-options="{ onValueChanged: onCLocalitateChanged }" />
                        <DxFormItem data-field="CCP" :col-span="1" :label="{ text: 'C.P.' }" />

                        <DxFormItem data-field="CAdresa" :col-span="4" editor-type="dxTextArea"
                            :editor-options="{ height: 80 }" :label="{ text: 'Adresă Completă' }" />
                    </DxFormItem>

                    <DxFormItem :visible="!showExtendedDetails" :col-count="3" :col-span="3">
                        <div class="show-more-container" style="display: flex; justify-content: center; margin: 1px 0;">
                            <DxButton :element-attr="{ class: 'show-more-btn' }"
                                text="Completează detalii suplimentare"
                                icon="chevrondown" type="normal"
                                styling-mode="text" @click="showExtendedDetails = true" />

                        </div>
                    </DxFormItem>

                    <DxFormItem item-type="group" caption="Configurare Financiară & Comericală"
                        :visible="showExtendedDetails" :col-count="2">
                        <DxFormItem :label="{ text: 'Bancă (Internă)' }">
                            <DxDropDownBox v-model:value="sBanci" :data-source="dsBanci" display-expr="Nume"
                                value-expr="Id" :show-clear-button="true" placeholder="Selectează bancă"
                                content-template="gridContent" :drop-down-options="{ width: 200 }">
                                <template #gridContent>
                                    <div class="dropdown-grid-container" style="height: 300px;">
                                        <DxDataGrid :data-source="dsBanci" :columns="['Nume']"
                                            :hover-state-enabled="true" :height="280" :remote-operations="true"
                                            @row-click="onBanciRowClick">
                                            <DxPaging :enabled="true" :page-size="5" />
                                            <DxFilterRow :visible="true" />
                                            <DxScrolling mode="virtual" />
                                            <DxGridToolbar>
                                                <DxGridToolbarItem location="after">
                                                    <DxButton icon="plus" type="success" height="25px" width="25px"
                                                        @click="onAddNewBank" />
                                                </DxGridToolbarItem>
                                                <DxGridToolbarItem name="searchPanel" />
                                            </DxGridToolbar>
                                        </DxDataGrid>
                                    </div>
                                </template>
                            </DxDropDownBox>
                        </DxFormItem>

                        <DxFormItem :label="{ text: 'Valută' }">
                            <DxDropDownBox v-model:opened="isValutaGridBoxOpened" :data-source="valutaSelectat"
                                v-model:value="sValuta" :show-clear-button="true" display-expr="Simbol" value-expr="Id"
                                placeholder="RON">
                                <template #content="{ data }">
                                    <DxDataGrid :data-source="dsValuta" :selected-row-keys="sValuta ? [sValuta] : []"
                                        :columns="['Simbol']" :hover-state-enabled="true" height="100%"
                                        @row-click="onValuteRowClick">
                                        <DxSelection mode="single" />
                                        <DxPaging :enabled="true" :page-size="5" />
                                        <DxFilterRow :visible="true" />
                                        <DxSearchPanel :visible="true" placeholder="Caută..." />
                                    </DxDataGrid>
                                </template>
                            </DxDropDownBox>
                        </DxFormItem>

                        <DxFormItem data-field="CapitalSocial" />
                        <DxFormItem data-field="CifraAfacere" />
                        <DxFormItem data-field="NrAngajati" :label="{ text: 'Nr. Angajați' }" />
                        <DxFormItem data-field="AdaosPret" :col-span="1" />
                        <DxFormItem data-field="Scadenta" :label="{ text: 'Termen de plată' }" :col-span="1"
                            :editor-options="{ readOnly: !canEditLimiteCredit }" />
                        <DxFormItem data-field="CreditLimita" :label="{ text: 'Limita de credit' }" :col-span="1"
                            :editor-options="{ readOnly: !canEditLimiteCredit }" />

                    </DxFormItem>

                    <DxFormItem item-type="group" caption="Contacte & Diverse" :visible="showExtendedDetails"
                        :col-count="2">
                        <DxFormItem data-field="Tel" :label="{ text: 'Telefon' }" />
                        <DxFormItem data-field="Fax" />
                        <DxFormItem data-field="Email" />

                        <DxFormItem data-field="Director" />



                        <DxFormItem data-field="Observatii" :col-span="2" :editor-options="{ height: 100 }"
                            editor-type="dxTextArea" />

                    </DxFormItem>

                    <DxFormItem item-type="group" caption="System Flags" :visible="showExtendedDetails" :col-count="2"
                        :col-span="2">
                        <DxFormItem data-field="AplicaTVAlaIncasare" editor-type="dxCheckBox"
                            :label="{ text: 'TVA la Încasare' }" />
                        <DxFormItem data-field="RegimSpecialTVA" editor-type="dxCheckBox" />
                        <DxFormItem data-field="Intern" editor-type="dxCheckBox"
                            :editor-options="{ onValueChanged: handleInternChange }" />
                        <DxFormItem data-field="Extern" editor-type="dxCheckBox"
                            :editor-options="{ onValueChanged: handleExternChange }"
                            :label="{ text: 'Extern Non UE' }" />
                        <DxFormItem data-field="ExternUE" editor-type="dxCheckBox"
                            :editor-options="{ onValueChanged: handleExternUEChange }" />
                        <DxFormItem data-field="Client" editor-type="dxCheckBox" />
                        <DxFormItem data-field="Furnizor" editor-type="dxCheckBox" />
                        <DxFormItem data-field="Angajat" editor-type="dxCheckBox" />
                        <DxFormItem data-field="Activ" editor-type="dxCheckBox" />

                        <DxFormItem data-field="AplicaTvaDefalcat" editor-type="dxCheckBox"
                            :label="{ text: 'Split TVA' }" />

                        <DxFormItem data-field="faraScadenta" editor-type="dxCheckBox" />
                        <DxFormItem data-field="CalculezPenalitati" editor-type="dxCheckBox" />
                        <DxFormItem data-field="Litigiu" editor-type="dxCheckBox" />
                    </DxFormItem>

                </DxForm>
                <div class="form-footer  footer-modern">
                    <div class="footer-right" style="margin-top: 1px; text-align: right;">
                        <DxButton text="Salvează Compania" type="success" @click="onSaveNewPartner" height="32px"
                            width="200px" styling-mode="outlined" :disabled="isSubmitting" />
                        <DxButton text="Închide" @click="isPartnerModalVisible = false" height="32px" width="200px"
                            styling-mode="outlined" />
                    </div>
                </div>
            </div>
        </DxPopupAdd>
        <DxPopupAdd :visible="isContactModalVisible" @hiding="isContactModalVisible = false"
            :closeOnOutsideClick="false" :showCloseButton="false" :showTitle="true" :width="800" :height="640">

            <template #title>
                <div class="popup-header">
                    <div class="popup-header-main">
                        <span class="popup-header-icon dx-icon-user"></span>
                        <div class="popup-header-texts">
                            <div class="popup-header-title">Adăugare contact</div>
                            <div class="popup-header-subtitle">
                                Completează detaliile contactului în pașii de mai jos
                            </div>
                        </div>
                    </div>
                    <div class="popup-header-meta">
                        <span class="status-chip status-chip--draft">
                            Nou
                        </span>
                    </div>
                </div>
            </template>

            <div class="popup-body-simple popup-body-modern">
                <div class="form-content form-content-modern">
                    <DxForm :form-data="contactData" :col-count="3" :col-span="3" label-alignment="center" ref="form">
                        <DxFormItem data-field="Prenume" :col-span="1" :col-count="1">
                            <DxRequiredRule message="Câmpul Prenume este obligatoriu" />
                        </DxFormItem>
                        <DxFormItem data-field="Nume" :col-span="1" :col-count="1">
                            <DxRequiredRule message="Câmpul Nume este obligatoriu" />
                        </DxFormItem>



                        <DxFormItem data-field="Titlu" :label="{ text: 'Funcția' }" :col-span="1" :col-count="1">

                            <DxRequiredRule message="Funcția este obligatorie" />
                        </DxFormItem>



                        <DxFormItem :label="{ text: 'Partener' }" :col-span="2" :col-count="2">
                            <DxRequiredRule message="Partenerul este obligatoriu" />
                            <DxDropDownBox v-model:value="sPartener" :data-source="dsParteneri" display-expr="Nume"
                                value-expr="ID" :show-clear-button="true" placeholder="Selectează partener"
                                content-template="gridContent">
                                <template #gridContent>
                                    <div class="dropdown-grid-container" style="height: 300px;">
                                        <DxDataGrid :data-source="dsParteneri" :columns="['Nume']"
                                            :hover-state-enabled="true" :height="280" :remote-operations="true"
                                            @row-click="onPartenerRowClick">
                                            <DxPaging :enabled="true" :page-size="5" />
                                            <DxFilterRow :visible="true" />
                                            <DxScrolling mode="virtual" />
                                            <DxGridToolbar>
                                                <DxGridToolbarItem location="after">
                                                    <DxButton icon="plus" type="success" height="25px" width="25px"
                                                        @click="onAddNewPartener" />
                                                </DxGridToolbarItem>
                                                <DxGridToolbarItem name="searchPanel" />
                                            </DxGridToolbar>
                                        </DxDataGrid>
                                    </div>
                                </template>
                            </DxDropDownBox>
                        </DxFormItem>

                        <DxFormItem data-field="MetodaContact" :label="{ text: 'Metodă de Comunicare' }"
                            editor-type="dxSelectBox" :editor-options="{
                                items: metodaContact,
                                placeholder: 'Selectează metoda de comunicare'
                            }">

                        </DxFormItem>


                        <DxFormItem data-field="TelMobil" :label="{ text: 'Telefon' }" />

                        <DxFormItem data-field="Email" :label="{ text: 'Email' }" />

                        <DxFormItem dataField="Adresa" :label="{ text: 'Adresă' }" :col-span="3" />
                        <!-- 
                        <DxFormItem dataField="EmailMarketing" :label="{ text: 'Acceptă Email Marketing' }"
                            editor-type="dxCheckBox" />
                        <DxFormItem dataField="SmsMarketing" :label="{ text: 'Acceptă SMS Marketing' }"
                            editor-type="dxCheckBox" />
                        <DxFormItem :col-span="1" /> -->

                        <!-- <DxFormItem :label="{ text: 'Companie' }">
                                <DxDropDownBox v-model:value="sPartener" :data-source="dsParteneri" display-expr="Nume"
                                    value-expr="ID" :show-clear-button="true" placeholder="Selectează companie"
                                    content-template="gridContent">
                                    <template #gridContent>
                                        <div class="dropdown-grid-container" style="height: 300px;">
                                            <DxDataGrid :data-source="dsParteneri" :columns="['Nume']"
                                                :hover-state-enabled="true" :height="280" :remote-operations="true"
                                                @row-click="onPartenerRowClick">
                                                <DxPaging :enabled="true" :page-size="5" />
                                                <DxFilterRow :visible="true" />
                                                <DxScrolling mode="virtual" />

                                                <DxGridToolbar>
                                                    <DxGridToolbarItem location="after">
                                                        <DxButton icon="plus" type="success" height="25px" width="25px"
                                                            @click="onAddNewPartener" />
                                                    </DxGridToolbarItem>
                                                    <DxGridToolbarItem name="searchPanel" />
                                                </DxGridToolbar>
                                            </DxDataGrid>
                                        </div>
                                    </template>
                                </DxDropDownBox>
                            </DxFormItem> -->

                        <DxFormItem :label="{ text: 'Țară' }" :col-span="1">
                            <DxDropDownBox :data-source="dsTari" v-model:value="sTara" :show-clear-button="true"
                                display-expr="Nume" value-expr="ID" placeholder="Selectează țara"
                                content-template="gridContent">
                                <template #gridContent>
                                    <div class="dropdown-grid-container" style="height: 300px;">
                                        <DxDataGrid :data-source="dsTari" :columns="['Nume']" :remote-operations="true"
                                            :hover-state-enabled="true" height="100%"
                                            @selection-changed="onValueSelectedTara($event)">
                                            <DxSelection mode="single" />
                                            <DxPaging :enabled="true" :page-size="5" />
                                            <DxFilterRow :visible="true" />
                                            <DxSearchPanel :visible="true" placeholder="Caută ..." />
                                        </DxDataGrid>
                                    </div>
                                </template>
                            </DxDropDownBox>
                        </DxFormItem>

                        <DxFormItem :label="{ text: 'Județ' }">
                            <DxDropDownBox v-model:opened="isJudetGridBoxOpened" :data-source="judetSelectat"
                                v-model:value="sJudet" :show-clear-button="true" display-expr="Nume" value-expr="ID"
                                placeholder="Selectează județul">
                                <template #content="{ data }">
                                    <div class="dropdown-grid-container" style="height: 300px;">
                                        <DxDataGrid :data-source="dsJudete" v-model:value="sJudet" :columns="['Nume']"
                                            :hover-state-enabled="true" height="100%"
                                            @selection-changed="onValueSelectedJudet($event)">
                                            <DxSelection mode="single" />
                                            <DxPaging :enabled="true" :page-size="5" />
                                            <DxFilterRow :visible="true" />
                                            <DxSearchPanel :visible="true" placeholder="Caută ..." />
                                        </DxDataGrid>
                                    </div>
                                </template>
                            </DxDropDownBox>
                        </DxFormItem>

                        <DxFormItem :label="{ text: 'Localitate' }" :col-span="1">
                            <DxDropDownBox :data-source="dsLocalitati" v-model:value="sLocalitate"
                                :show-clear-button="true" display-expr="Localitate" value-expr="ID"
                                placeholder="Selectează localitatea" content-template="gridContent">
                                <template #gridContent>
                                    <div class="dropdown-grid-container" style="height: 300px;">
                                        <DxDataGrid :data-source="dsLocalitati" :columns="['Localitate']"
                                            :remote-operations="true" :hover-state-enabled="true" height="100%"
                                            @selection-changed="onValueSelectedLocalitate($event)">
                                            <DxSelection mode="single" />
                                            <DxPaging :enabled="true" :page-size="5" />
                                            <DxFilterRow :visible="true" />
                                            <DxSearchPanel :visible="true" placeholder="Caută ..." />
                                        </DxDataGrid>
                                    </div>
                                </template>
                            </DxDropDownBox>
                        </DxFormItem>

                        <DxFormItem data-field="Note" :col-span="3" :editor-options="{ height: 80 }"
                            editor-type="dxTextArea" />


                    </DxForm>
                </div>

                <div class=" footer-fixed footer-modern">
                    <div class="footer-right">
                        <DxButton text="Salvează" type="success" width="120" height="32" styling-mode="outlined"
                            :disabled="!formData.AccountID" @click="onSaveAddContact" />
                        <DxButton text="Închide" type="danger" width="120" height="32" styling-mode="outlined"
                            @click="isContactModalVisible = false" />
                    </div>
                </div>
            </div>
        </DxPopupAdd>

        <DxPopupAdd :visible="isBankModalVisible" :width="800" :height="750" :show-title="true" title="Adăugare Bancă"
            @hiding="isBankModalVisible = false">
            <template #title>
                <div class="popup-header">
                    <div class="popup-header-main">
                        <span class="popup-header-icon dx-icon-user"></span>
                        <div class="popup-header-texts">
                            <div class="popup-header-title">Adăugare bancă</div>
                            <div class="popup-header-subtitle">
                                Completează detaliile băncii
                            </div>
                        </div>
                    </div>
                    <div class="popup-header-meta">
                        <span class="status-chip status-chip--draft">
                            Nou
                        </span>
                    </div>
                </div>
            </template>
            <div class="popup-body-modern">
                <DxForm :form-data="newBankData" :col-count="2" :col-span="2">

                    <DxFormItem data-field="Ordine" />
                    <!-- <DxFormItem data-field="PartenerID" /> -->
                    <DxFormItem data-field="Cod" />
                    <DxFormItem data-field="Nume" />
                    <!-- <DxFormItem data-field="ValutaID" /> -->


                    <DxFormItem :label="{ text: 'Valută' }">
                        <DxDropDownBox v-model:value="sValute" :data-source="dsValute" display-expr="Nume"
                            value-expr="Id" :show-clear-button="true" placeholder="Selectează "
                            content-template="gridContent">
                            <template #gridContent>
                                <div class="dropdown-grid-container" style="height: 300px;">
                                    <DxDataGrid :data-source="dsValute" :columns="['Nume']" :hover-state-enabled="true"
                                        :height="280" :remote-operations="true" @row-click="onValuteRowClick">
                                        <DxPaging :enabled="true" :page-size="5" />
                                        <DxFilterRow :visible="true" />
                                        <DxScrolling mode="virtual" />
                                    </DxDataGrid>
                                </div>
                            </template>
                        </DxDropDownBox>
                    </DxFormItem>
                    <DxFormItem data-field="CodIBAN" />
                    <DxFormItem data-field="CodBIC" />
                    <DxFormItem data-field="CodSWIFT" />
                    <DxFormItem data-field="TextFC" />
                    <DxFormItem data-field="Principala" editor-type="dxCheckBox" />

                    <DxFormItem data-field="Activ" editor-type="dxCheckBox" />

                </DxForm>
                <div class="form-footer footer-fixed footer-modern">
                    <div class="footer-right" style="margin-top: 20px; text-align: right;">
                        <DxButton text="Salvează Banca" type="success" @click="onSaveNewBank" height="32px"
                            width="200px" styling-mode="outlined" />
                        <DxButton text="Închide" @click="isBankModalVisible = false" height="32px" width="200px"
                            styling-mode="outlined" />
                    </div>
                </div>
            </div>
        </DxPopupAdd>


    </div>
</template>

<script lang="ts">
import CrmContacts from '@/services/Comercial/CrmContacts';
import DxDropDownButton, { DxDropDownButtonTypes } from 'devextreme-vue/drop-down-button';
import DxSelectBox from 'devextreme-vue/select-box';
import { defineComponent, ref } from 'vue';
import { DxButton } from 'devextreme-vue/button';
import DxPopupAdd from 'devextreme-vue/popup';
import { DxSimpleItem, DxLabel } from 'devextreme-vue/form';
import { DxScrollView } from 'devextreme-vue/scroll-view';
import { DxItem as DxFormItem } from 'devextreme-vue/form';
import AnafService from '@/services/AnafService';
import { DxForm, DxGroupItem } from "devextreme-vue/form"
import {
    DxItem as DxGridToolbarItem,
    DxLookup,
    DxColumn,
    DxDataGrid,
    DxFilterRow,
    DxLoadPanel,
    DxPaging,
    DxSelection,
    DxSorting,
    DxStateStoring,
    DxToolbar as DxGridToolbar,
    DxEditing,
    DxColumnChooser,
    DxGrouping,
    DxGroupPanel,
    DxTexts,
    DxExport,
    DxSearchPanel,
    DxMasterDetail,
    DxPopup,
    DxForm as DxFormGrid,
    DxScrolling,
    DxHeaderFilter,
    DxToolbarItem,
    DxPager

} from 'devextreme-vue/data-grid';
import DxValidator, { DxRequiredRule, DxCustomRule } from 'devextreme-vue/validator'
import ODataStore from 'devextreme/data/odata/store';
import AppSetting from '@/settings/appSettings';
import notify from 'devextreme/ui/notify';
import { jsPDF } from 'jspdf';
import { locale, loadMessages } from 'devextreme/localization';
import { exportDataGrid as exportDataGridPdf } from 'devextreme/pdf_exporter';
import { exportDataGrid as exportDataGridExcel } from 'devextreme/excel_exporter';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver';
import CrmSales from '@/services/Comercial/CrmSales';
import DataSource from "devextreme/data/data_source";
import DxDropDownBox from "devextreme-vue/drop-down-box";
import { DxItem } from "devextreme-vue/responsive-box";
import JwtServices from '@/services/JwtServices';
import { height } from 'devexpress-reporting/scopes/reporting-designer-bands-metadata';
import PAR_Parteneri from "@/services/PAR/PAR_Parteneri";
import DxDateBox from "devextreme-vue/date-box";
import { useAddPartener } from '@/composable/useAddPartener';
export default defineComponent({
    components: {
        DxItem,
        DxDropDownBox,
        DxGridToolbar,
        DxDataGrid,
        DxColumn,
        DxSorting,
        DxSelection,
        DxFilterRow,
        DxStateStoring,
        DxLoadPanel,
        DxPaging,
        DxButton,
        DxEditing,
        DxPopupAdd,
        DxForm,
        DxSimpleItem,
        DxLabel,
        DxScrollView,
        DxLookup,
        DxColumnChooser,
        DxGrouping,
        DxGroupPanel,
        DxTexts,
        DxExport,
        DxSearchPanel,
        DxMasterDetail,
        DxPopup,
        DxToolbarItem,
        DxFormGrid,
        DxGridToolbarItem,
        DxScrolling,
        DxHeaderFilter,
        DxDropDownButton,
        DxSelectBox,
        DxFormItem,
        DxRequiredRule,
        DxDateBox,
        DxPager
    },

    setup() {
        const { isSubmitting, idempotencyKey, resetIdempotencyKey } = useAddPartener();
        return { isSubmitting, idempotencyKey, resetIdempotencyKey };
    },

    data() {
        return {
            deleteConfirmationMessage: "Sigur doriți să ștergeți această înregistrare?",
            dsTari: {} as ODataStore,
            dsJudete: {} as ODataStore,
            dsLocalitati: {} as ODataStore,
            sex: [
                'Masculin',
                'Feminin'
            ],
            metodaContact: [
                'Telefonic',
                'Email'
            ],
            probabilityList: [0, 25, 50, 75, 100],
            sStatus: 'BE62B2A3-AEA9-4706-ADED-934622DBEFD9',
            isStatusGridBoxOpened: false,
            dsStatus: {} as ODataStore,
            campanieSelectat: [],
            isCampaniiGridBoxOpened: false,
            sCampanie: null,
            statusList: [],
            intervalList: [],
            partenerSelectat: [],
            isParteneriGridBoxOpened: false,
            sPartener: null,

            contactSelectat: [],
            isContacteGridBoxOpened: false,
            sContact: null,

            proiectSelectat: [],
            isProiecteGridBoxOpened: false,
            sProiect: null,

            valutaSelectat: [],
            isValutaGridBoxOpened: false,
            sValuta: null,

            dsContacts: {} as ODataStore,
            dsSales: {} as ODataStore,
            dsParteneri: {} as ODataStore,
            dsCampaniiMarketing: {} as ODataStore,
            dsValuta: {} as ODataStore,
            dsSalesSources: {} as ODataStore,
            dsProiecte: {} as ODataStore,
            dsParteneriFiscal: {} as ODataStore,
            isModalVisible: false,
            isContactModalVisible: false,
            isPanelOpened: ref(false),
            dataGrid: ref<DxDataGrid | null>(null),
            // deleteConfirmationMessage: "Sigur doriți să ștergeți această înregistrare?",
            panelData: null as any,
            activeFilter: 'all', // Track active quick filter
            startDate: null as Date | null,
            endDate: null as Date | null,
            searchQuery: '',
            statsData: {
                total: 0,
                pipelineValue: 0,
                wonCount: 0,
                negotiationCount: 0
            },


            formData: {
                Titlu: '',
                ContactID: null,
                AccountID: null,
                IntervalCumparare: 'Necunoscut',
                BugetEstimat: null,
                Note: '',
                Cerere: '',
                Oferta: '',
                DataInchidereEstimat: null,
                VenitEstimat: '',
                Probabilitate: 0,
                Status: null,
                Owner: '',
                VenitRealizat: null,
                DataInchis: null,
                UltimulStatus: '',
                MotivInchidere: '',
                IndustrieID: null,
                CampanieID: null,
                CostEstimat: null,
                CostEfectiv: null,
                ListaProduse: '',
                Cod: '',
                Discount: null,
                ValutaID: '0A61647E-7391-4087-BC01-8EB9C2CEDEDD',
                Curs: null,
                SursaID: null,
                Data: new Date(),
                ProiectID: null,
                StatusID: 'BE62B2A3-AEA9-4706-ADED-934622DBEFD9',
                ZonaID: null,
                ProbabilitateCastig: null,
            },
            contactData: {
                Nume: '',
                Prenume: null,
                DataNasterii: null,
                Sex: '',
                Titlu: '',
                AccountID: null,
                Email: '',
                TelMunca: '',
                TelMobil: '',
                Fax: '',
                TaraID: '',
                JudetID: null,
                LocalitateID: null,
                Adresa: '',
                MetodaContact: '',
                Note: '',
                Activ: true,
                Owner: '',
                Imagine: null,
                ContactPrimar: true
            },
            tabs: [
                "Info. General",
                "Relații",
                "Info. Financiar",
                "Achiziție",
                "Detalii"
            ],
            newPartnerData: {
                Nume: '',
                CUI: '',
                Cod: '',
                Fiscal: '',
                Client: null,
                Furnizor: null,
                Numar: '',
                Strada: '',
                Localitate: '',
                JudetID: null,
                TaraID: null,
                ZonaID: null,
                Cont: '',
                Banca: '',
                Litigiu: false,
                Extern: false,
                Intern: true,
                Observatii: '',
                AdaosPret: null,
                faraScadenta: false,
                ValutaID: '0A61647E-7391-4087-BC01-8EB9C2CEDEDD',
                Director: '',
                Fax: '',
                Tel: '',
                Email: '',
                www: '',
                GrupID: null,
                CP: '',
                CStrada: '',
                CLocalitate: '',
                CJudetID: null,
                CTaraID: null,
                CCP: '',
                Bloc: '',
                CBloc: '',
                Numarstrada: '',
                Scarabloc: '',
                CNumarstrada: '',
                CScarabloc: '',
                Scadenta: null,
                AgentID: null,
                Angajat: false,
                Memo: '',
                CreditLimita: null,
                DirectorEconomic: '',
                PersoanaContact: '',
                AplicaTVAlaIncasare: false,
                CifraAfacere: null,
                NrAngajati: null,
                Activ: null,
                Owner: '',
                CalculezPenalitati: true,
                ParRecomandareID: null,
                CapitalSocial: null,
                AngajatID: null,
                ExternUE: false,
                StructuraLegaturaID: null,
                PartenerMasterID: null,
                RegimSpecialTVA: false,
                AplicaTvaDefalcat: false,
                Et: '',
                Ap: '',
                Adresa: '',
                CEt: '',
                CAp: '',
                CAdresa: '',
                CalculezPenalitatiDeLa: null,
                Prefix: '',
                Sufix: '',
                Caen: '',
                PunctID: null,
                ParentID: null,
            },
            cuiOptions: {
                placeholder: 'Introdu CUI',
                onEnterKey: () => this.onSearchAnaf(),
                buttons: [{
                    name: 'searchAnaf',
                    location: 'after',
                    options: {
                        icon: 'search',
                        width: 26,
                        height: 26,
                        type: 'default',
                        hint: 'Caută în ANAF',
                        onClick: () => this.onSearchAnaf()
                    }
                }]
            },
            showExtendedDetails: false,
            isPartnerModalVisible: false,
            sBanci: null,
            sTara: null,
            sJudet: null,
            sLocalitate: null,
            isTariGridBoxOpened: false,
            isJudetGridBoxOpened: false,
            isLocalitatiGridBoxOpened: false,
            judetSelectat: [],
            localitateSelectat: [],
            dsBanci: {} as ODataStore,
            dsValute: {} as ODataStore,
            sValute: null,
            dsGrupuri: {} as ODataStore,
            dsZona: {} as ODataStore,
            newBankData: {
                Ordine: null,
                PartenerID: null,
                Cod: '',
                Nume: '',
                ValutaID: null,
                CodIBAN: '',
                CodBIC: '',
                CodSWIFT: '',
                TextFC: '',
                Principala: false,
                Activ: true,
            },
            isBankModalVisible: false,
            eurRate: 1,
            dsPartnerTari: null as DataSource | null,
            dsCTari: null as DataSource | null,
            dsPartnerJudete: null as DataSource | null,
            dsCJudete: null as DataSource | null,
            GRUP_PERSOANA_FIZICA_ID: 'd41f9383-09b5-42c7-a33c-5050a438752a',
            GRUP_SMB_ID: '646a5caa-f34a-43ee-aebb-f1509b3e005e',
            canEditLimiteCredit: false,
            ultimulJudetInAdresa: null as string | null,
            ultimulJudetInCAdresa: null as string | null,
            ultimaLocalitateInAdresa: null as string | null,
            ultimaCLocalitateInCAdresa: null as string | null,
        };
    },
    watch: {
        canEditLimiteCredit(newVal) {
            const formInstance = this.$refs.newPartnerFormRef?.instance;
            if (!formInstance) return;
            formInstance.itemOption('Scadenta', 'editorOptions', { readOnly: !newVal });
            formInstance.itemOption('CreditLimita', 'editorOptions', { readOnly: !newVal });
        },

        'newPartnerData.Fiscal'(newVal) {
            if (newVal === 'F') {
                this.newPartnerData.GrupID = this.GRUP_PERSOANA_FIZICA_ID;
            } else if (newVal === 'P' || newVal === 'N') {
                this.newPartnerData.GrupID = this.GRUP_SMB_ID;
            }
        },

        'formData.IntervalCumparare': function (newVal) {
            if (!newVal) return;
            const now = new Date();
            let newDate = null;

            switch (newVal) {
                case 'Imediat':
                    // Current date + 2 weeks
                    newDate = new Date(now.getTime() + 14 * 24 * 60 * 60 * 1000);
                    break;
                case 'Luna aceasta':
                    // Last day of current month
                    newDate = new Date(now.getFullYear(), now.getMonth() + 1, 0);
                    break;
                case 'Anul acesta':
                    // Last day of current year
                    newDate = new Date(now.getFullYear(), 11, 31);
                    break;
                case 'Trimestrul acesta': {
                    // Last day of current quarter
                    const currentMonth = now.getMonth(); // 0-11
                    const quarterEndMonth = Math.floor(currentMonth / 3) * 3 + 2;
                    newDate = new Date(now.getFullYear(), quarterEndMonth + 1, 0);
                    break;
                }
                case 'Trimestrul următor': {
                    // Last day of next quarter
                    const currentMonth = now.getMonth();
                    const currentQuarter = Math.floor(currentMonth / 3);
                    const nextQuarter = currentQuarter + 1;
                    let targetYear = now.getFullYear();
                    let targetQuarter = nextQuarter;

                    if (nextQuarter > 3) {
                        targetQuarter = 0;
                        targetYear++;
                    }
                    const quarterEndMonth = targetQuarter * 3 + 2;
                    newDate = new Date(targetYear, quarterEndMonth + 1, 0);
                    break;
                }
                default:
                    return;
            }

            if (newDate) {
                this.formData.DataInchidereEstimat = newDate;
            }
        },
        sContact(newId) {
            if (newId) {
                this.dsContacts.store().byKey(newId).then(x => {
                    if (!x) return;
                    x.FullName = `${x.Nume ?? ''} ${x.Prenume ?? ''}`.trim() || '(fara nume)';
                    this.contactSelectat = [x];
                });
            } else {
                this.contactSelectat = [];
            }
        },

        sCampanie(newId) {
            if (newId) {
                this.dsCampaniiMarketing.store().byKey(newId).then(x => {
                    if (!x) return;
                    x.Denumire = (x.Denumire ?? '(fara nume)');
                    this.campanieSelectat = [x];
                });

            } else {
                this.campanieSelectat = [];
            }
        },

        sPartener(newId) {
            if (newId) {
                this.dsParteneri.store().byKey(newId).then(x => {
                    if (!x) return;
                    x.Nume = (x.Nume ?? '(fara nume)');
                    this.partenerSelectat = [x];
                });

                // Filter contacts by selected company
                this.dsContacts.filter(["AccountID", "=", newId]);
                this.dsContacts.load();

                // Clear contact if company changes
                this.sContact = null;
                this.formData.ContactID = null;
            } else {
                this.partenerSelectat = [];
                // Clear filter
                this.dsContacts.filter(null);
                this.dsContacts.load();

                // Clear contact if company is cleared
                this.sContact = null;
                this.formData.ContactID = null;
            }
        },
        sProiect(newId) {
            if (newId) {
                this.dsProiecte.store().byKey(newId).then(x => {
                    if (!x) return;
                    x.Cod = (x.Cod ?? '(fara nume)');
                    this.proiectSelectat = [x];
                });

            } else {
                this.proiectSelectat = [];
            }
        },
        sValuta(newId) {
            if (newId) {
                this.dsValuta.byKey(newId).then(x => {
                    if (!x) return;
                    x.Simbol = (x.Simbol ?? '(fara simbol)');
                    this.valutaSelectat = [x];
                });
            } else {
                this.valutaSelectat = [];
            }
        },
        sParteneriFiscal(newId) {
            if (newId) {
                this.dsParteneriFiscal.store().byKey(newId).then(x => {
                    if (!x) return;
                    x.Nume = (x.Nume ?? '(fara nume)');
                    this.partenerFiscalSelectat = [x];
                });
            } else {
                this.partenerFiscalSelectat = [];
            }
        },

    },
    computed: {
        totalOpportunities(): number {
            return this.statsData.total;
        },
        totalPipelineValue(): number {
            return this.statsData.pipelineValue;
        },
        wonCount(): number {
            return this.statsData.wonCount;
        },
        negotiationCount(): number {
            return this.statsData.negotiationCount;
        },
        statusHeaderFilterDataSource(): any[] {
            return this.statusList.map((s: any) => ({
                text: s.Nume,
                value: ['Status.Nume', '=', s.Nume]
            }));
        }
    },
    methods: {

        onValueSelectedTara(e) {
            this.isTaraGridBoxOpened = false;

            if (e.selectedRowKeys.length > 0) {
                this.sTara = e.selectedRowKeys[0];

            } else {
                this.sTara = null;
            }
            this.contactData.TaraID = this.sTara;

        },

        async fetchEurRate() {
            try {
                const store = new ODataStore({
                    url: AppSetting.API_Url_ComercialOdata + 'ERP_CursValutar',
                    key: 'Id',
                    version: 4,
                    beforeSend: (e) => {
                        e.headers = {
                            "Content-Type": "application/json",
                            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
                        };
                    }
                });

                const result = await store.load({
                    filter: ["Simbol", "=", "EUR"],
                    sort: [{ selector: "Data", desc: true }],
                    take: 1
                });

                if (result && result.length > 0) {
                    this.eurRate = result[0].Curs || 1;
                    console.log("EUR Exchange Rate fetched:", this.eurRate);
                    // Recalculate statistics if data is already loaded
                    this.calculateStatistics();
                }
            } catch (error) {
                console.error("Error fetching EUR rate:", error);
            }
        },

        onValueSelectedJudet(e) {
            this.isJudetGridBoxOpened = false;

            if (e.selectedRowKeys.length > 0) {
                this.sJudet = e.selectedRowKeys[0];

            } else {
                this.sJudet = null;
            }
            this.contactData.JudetID = this.sJudet;

            let _filter;

            if (this.sJudet != null) {
                _filter = ["JudetId", "=", this.sJudet];
            } else {
                _filter = null;
            }

            this.dsLocalitati.filter(_filter);
            this.dsLocalitati.load();

        },
        onValueSelectedLocalitate(e) {
            this.isLocalitateGridBoxOpened = false;

            if (e.selectedRowKeys.length > 0) {
                this.sLocalitate = e.selectedRowKeys[0];

            } else {
                this.sLocalitate = null;
            }
            this.contactData.LocalitateID = this.sLocalitate;
        },
        onCampanieRowClick(e) {
            if (e.data && e.data.ID) {
                this.sCampanie = e.data.ID;
                this.formData.CampanieID = this.sCampanie;

                setTimeout(() => {
                    this.isCampaniiGridBoxOpened = false;
                }, 150);
            }
        },
        onSaveNewBank() {
            if (!this.newBankData.Nume || this.newBankData.Nume.trim() === '') {
                notify('Completați câmpul obligatoriu "Nume"!', 'error', 1000);
                return;
            }

            console.log(this.newBankData);
            const body = this.newBankData;
            const savedBankData = { ...this.newBankData }; // Capture data before reset

            PAR_Parteneri.saveBank(body).then((response) => {
                this.isBankModalVisible = false;
                notify('Datele au fost salvate cu succes!', 'success', 1000);

                const newId = response?.data?.ID || response?.data?.Id || response?.data?.id || response?.data;

                // Refresh data source and set selection
                this.dsBanci.reload().then(() => {
                    if (newId) {
                        console.log("Setting new bank:", newId, savedBankData.Nume);
                        this.sBanci = newId;
                        this.newPartnerData.Banca = savedBankData.Nume;
                    }
                });

                this.newBankData = {
                    PartenerID: null,
                    Cod: null,
                    Nume: null,
                    CodIBAN: null,
                    CodBIC: null,
                    Principala: null,
                    CodSWIFT: null,
                    ValutaID: null,
                    Ordine: null,
                    Activ: null,
                    TextFC: null,
                };
            }).catch((error) => {
                console.error(error);
                notify('Datele există deja sau a apărut o eroare!', 'error', 2000);
            });
        },
        onSaveNewPartner() {
            if (!this.newPartnerData.Nume || this.newPartnerData.Nume.trim() === '') {
                notify('Completați câmpul obligatoriu "Nume"!', 'error', 1000);
                return;
            }

            if (!this.newPartnerData.Fiscal) {
                notify('Completați câmpul obligatoriu "Tip Fiscal"!', 'error', 1000);
                return;
            }
            if (!this.newPartnerData.TaraID) {
                notify('Completați câmpul obligatoriu "Țara"!', 'error', 1000);
                return;
            }
            if (!this.newPartnerData.JudetID) {
                notify('Completați câmpul obligatoriu "Județ"!', 'error', 1000);
                return;
            }
            if (!this.newPartnerData.Localitate || String(this.newPartnerData.Localitate).trim() === '') {
                notify('Completați câmpul obligatoriu "Localitate"!', 'error', 1000);
                return;
            }
            if (!this.newPartnerData.GrupID) {
                this.showExtendedDetails = true;
                notify('Completați câmpul obligatoriu "Grup"!', 'error', 1000);
                return;
            }
            if (!this.newPartnerData.ZonaID) {
                this.showExtendedDetails = true;
                notify('Completați câmpul obligatoriu "Zona"!', 'error', 1000);
                return;
            }

            console.log(this.newPartnerData);
            const body = this.newPartnerData;
            const savedPartnerData = { ...this.newPartnerData }; // Capture data before reset

            this.isSubmitting = true;
            PAR_Parteneri.save(body, this.idempotencyKey).then((response) => {
                this.isSubmitting = false;
                this.isPartnerModalVisible = false;
                notify('Datele au fost salvate cu succes!', 'success', 1000);

                const newId = response.data?.ID || response.data?.Id;

                if (newId) {
                    this.formData.AccountID = newId;
                    this.sPartener = newId;

                    // Mapare adresa
                    if (response.data.Adresa) this.formData.Adresa = response.data.Adresa;
                    if (response.data.TaraID) this.formData.TaraID = response.data.TaraID;
                    if (response.data.JudetID) this.formData.JudetID = response.data.JudetID;

                    console.log("ID setat pentru contact:", this.formData.AccountID);
                }

                this.dsParteneri.reload();

            }).catch((error) => {
                this.isSubmitting = false;
                const status = error?.response?.status;
                const data = error?.response?.data;

                if (status === 409 && data?.code === "CUI_EXISTS") {
                    notify(data.message || 'Partenerul cu acest CUI există deja!', 'error', 2000);
                    return;
                }

                console.error(error);
            });
        },
        onStatusRowClick(e) {
            this.isStatusGridBoxOpened = false;

            if (e.data) {
                this.sStatus = e.data.ID;
                this.formData.StatusID = e.data.ID;
            } else {
                this.sStatus = null;
            }
        },
        handleInternChange(e) {
            if (e.value) {
                this.newPartnerData.Extern = false;
                this.newPartnerData.ExternUE = false;
            }
        },

        handleExternChange(e) {
            if (e.value) {
                this.newPartnerData.Intern = false;
                this.newPartnerData.ExternUE = false;
            }
        },
        handleExternUEChange(e) {
            if (e.value) {
                this.newPartnerData.Intern = false;
                this.newPartnerData.Extern = false;
            }
        },
        onValuteRowClick(e) {
            this.isValuteGridBoxOpened = false;

            if (e.data) {
                this.sValute = e.data.Id;
                this.newBankData.ValutaID = e.data.Id;
            } else {
                this.sValute = null;
            }
        },
        formatDate(value: Date | string) {
            const d = new Date(value);
            return d.toLocaleDateString('ro-RO');
        },
        // Calculate statistics from data
        calculateStatistics() {
            const dataGrid = this.$refs.dataGrid?.instance;
            if (!dataGrid) return;
            // Get current filter from the grid
            const combinedFilter = dataGrid.getCombinedFilter();
            // Load data using the filter from ODataStore
            // Note: dsSales is an ODataStore, load returns a Promise
            this.dsSales.load({ filter: combinedFilter }).then((data: any[]) => {
                // Total opportunities (filtered)
                this.statsData.total = data.length;
                this.statsData.pipelineValue = data.reduce((sum, item) => {
                    let value = (item.VenitEstimat || item.BugetEstimat || 0);
                    // Convert to EUR if it's in RON or other currency
                    const currencySimbol = (item.Valuta?.Simbol || '').toUpperCase();
                    if (currencySimbol === 'RON' || !currencySimbol) {
                        value = value / this.eurRate;
                    }
                    // If it's already EUR, we don't need to do anything as we want everything in EUR
                    return sum + value;
                }, 0);
                // Won count (filtered)
                const wonID = '0B2BCD0D-1131-46CC-A4B2-AC685FCCB80E'.toUpperCase();
                const won = data.filter(item => {
                    const itemStatusID = (item.StatusID || item.StatusId || '').toString().toUpperCase();
                    if (itemStatusID === wonID) return true;

                    const statusName = item.Status?.Nume || item.Status;
                    return statusName === 'Câștigat' || statusName === 'Castigat';
                }).length;
                this.statsData.wonCount = won;
                // Negotiation count (filtered)
                this.statsData.negotiationCount = data.filter(item => {
                    const statusName = item.Status?.Nume || item.Status;
                    return statusName === 'Negociere';
                }).length;
            }).catch(e => {
                console.error("Error calculating statistics with filter:", e);
            });
        },
        fetchStatuses() {
            const statusStore = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_ComercialOdata + 'CRM_StariOportunitati',
                    key: 'ID',
                    version: 4,
                    beforeSend: (e: any) => {
                        e.headers = {
                            "Content-Type": "application/json",
                            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
                        };
                    }
                },
                sort: [{ selector: "NrOrd", desc: false }]
            });

            statusStore.load().then((data) => {
                this.statusList = data;
            }).catch(error => {
                console.error("Failed to load statuses for filters", error);
            });
        },


        getStatusClass(status: string): string {
            const statusMap: { [key: string]: string } = {
                'Castigat': 'status-won',
                'Inchis': 'status-closed',
                'Nou': 'status-new',
                'Identificat': 'status-identificat',
                'Calificare': 'status-calificare',
                'Demo': 'status-demo',
                'Ofertare': 'status-offer',
                'Ofertate': 'status-offer', // Fallback if user meant this literally
                'Negociere': 'status-negotiation',
            };
            return statusMap[status] || 'status-default';
        },

        formatCurrency(value: number): string {
            return new Intl.NumberFormat('ro-RO', {
                style: 'currency',
                currency: 'EUR',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }).format(value);
        },

        calculateBugetEUR(rowData: any): number {
            let value = rowData.BugetEstimat || 0;
            if (rowData.Valuta?.Simbol === 'RON' || !rowData.Valuta?.Simbol) {
                value = value / this.eurRate;
            }
            return value;
        },

        getProbabilityColor(probability: number): string {
            if (probability >= 75) return '#10b981'; // Green
            if (probability >= 50) return '#3b82f6'; // Blue
            if (probability >= 25) return '#f59e0b'; // Orange
            return '#ef4444'; // Red
        },


        // applyQuickFilter(filter) {
        //     this.activeFilter = filter;

        //     if (filter === "all") {
        //         this.currentFilter = null;
        //     } else {
        //         this.currentFilter = `Status/Nume eq '${filter}'`;
        //     }

        //     this.$refs.grid.instance.refresh();
        // },
        // Quick filter method
        applyQuickFilter(filterType: string) {
            this.activeFilter = filterType;
            this.applyGlobalFilter();
        },

        onContactRowClick(e) {
            if (e.data && e.data.ID) {
                this.sContact = e.data.ID;
                this.formData.ContactID = e.data.ID;

                setTimeout(() => {
                    this.isContacteGridBoxOpened = false;
                }, 150);
            }
        },

        onValueSelectedProiect(e) {
            this.isProiecteGridBoxOpened = false;

            if (e.selectedRowKeys.length > 0) {
                this.sProiect = e.selectedRowKeys[0];

            } else {
                this.sProiect = null;
            }
            this.formData.ProiectID = this.sProiect;
        },
        onValutaRowClick(e) {
            if (e.data && e.data.Id) {
                this.sValuta = e.data.Id;
                this.formData.ValutaID = e.data.Id;

                setTimeout(() => {
                    this.isValutaGridBoxOpened = false;
                }, 150);
            }
        },
        onAddNewContact() {
            this.contactData.AccountID = this.sPartener;
            this.isContactModalVisible = true;
            this.contactData.TaraID = 'D31C3594-8D39-4355-9A13-FD699A1B7290'; // Default Country: Romania
            this.sTara = this.contactData.TaraID;
            this.sJudet = null;
            this.sLocalitate = null;
        },

        onValueSelectedPartener(e) {

            this.isParteneriGridBoxOpened = false;

            if (e.selectedRowKeys.length > 0) {
                this.sPartener = e.selectedRowKeys[0];

            } else {
                this.sPartener = null;
            }
            this.formData.AccountID = this.sPartener;

            // Filter applied via sPartener watcher
            // let _filter;

            // if (this.sPartener != null) {
            //    _filter = ["AccountID", "=", this.sPartener];
            // } else {
            //    _filter = null;
            // }

            // this.dsContacts.filter(_filter);
            // this.dsContacts.load();

        },

        onBanciRowClick(e) {
            // 1. Close the dropdown
            this.isBanciGridBoxOpened = false;

            // 2. Update the value
            if (e.data) {
                this.sBanci = e.data.Id;
                // SAVE NAME INSTEAD OF ID
                this.newPartnerData.Banca = e.data.Nume;

                // Legacy/Other
                this.newBankData.Banca = e.data.Nume;
                this.newBankData.PartenerId = e.data.Id;
            } else {
                this.sBanci = null;
                this.newPartnerData.Banca = '';
                this.newBankData.PartenerId = null;
            }
        },
        onAddNewBank() {
            this.isBankModalVisible = true;
            this.newBankData.ValutaID = '0A61647E-7391-4087-BC01-8EB9C2CEDEDD';
        },

        // Nomenclatorul ERP_Judete conține rânduri istorice fără Nume completat (doar Cod
        // numeric, orfane din import) — filtrate aici ca să nu apară goale în dropdown.
        buildDsPartnerJudete(taraId) {
            const filtruNumeCompletat = [['Nume', '<>', null], 'and', ['Nume', '<>', '']];
            const filtru = taraId ? [['TaraID', '=', taraId], 'and', filtruNumeCompletat] : filtruNumeCompletat;
            return new DataSource({
                store: {
                    type: 'odata', url: AppSetting.API_Url_ComercialOdata + 'ERP_Judete', key: 'ID', keyType: 'Guid',
                    version: 4, fieldTypes: { TaraID: 'Guid' },
                    beforeSend: (e: any) => {
                        e.headers = { 'Content-Type': 'application/json', Authorization: 'Bearer ' + localStorage.getItem('ERA_Jwt') };
                    },
                },
                select: ['ID', 'Nume'],
                filter: filtru,
                sort: [{ selector: 'Nume', desc: false }],
            });
        },

        onTaraChanged(e) {
            const id = e.value;
            this.newPartnerData.JudetID = null;
            this.dsPartnerJudete = this.buildDsPartnerJudete(id);
            const taraNume = e.component.option('selectedItem')?.Nume;
            if (taraNume) this.newPartnerData.Adresa = taraNume;
            this.ultimulJudetInAdresa = null;
            this.ultimaLocalitateInAdresa = null;
        },

        onCTaraChanged(e) {
            const id = e.value;
            this.newPartnerData.CJudetID = null;
            this.dsCJudete = this.buildDsPartnerJudete(id);
            const taraNume = e.component.option('selectedItem')?.Nume;
            if (taraNume) this.newPartnerData.CAdresa = taraNume;
            this.ultimulJudetInCAdresa = null;
            this.ultimaCLocalitateInCAdresa = null;
        },

        aplicaJudetInAdresa(judetNume) {
            let current = (this.newPartnerData.Adresa || '').trim();
            if (this.ultimulJudetInAdresa) {
                current = current.replace(this.ultimulJudetInAdresa, '').replace(/,\s*,/g, ',').replace(/(^,\s*|,\s*$)/g, '').trim();
            }
            this.newPartnerData.Adresa = current ? `${current}, ${judetNume}` : judetNume;
            this.ultimulJudetInAdresa = judetNume;
        },

        onJudetChanged(e) {
            const judetNume = e.component.option('selectedItem')?.Nume;
            if (!judetNume) return;
            this.aplicaJudetInAdresa(judetNume);
        },

        aplicaLocalitateInAdresa(localitate) {
            let current = (this.newPartnerData.Adresa || '').trim();
            if (this.ultimaLocalitateInAdresa) {
                current = current.replace(this.ultimaLocalitateInAdresa, '').replace(/,\s*,/g, ',').replace(/(^,\s*|,\s*$)/g, '').trim();
            }
            this.newPartnerData.Adresa = localitate ? (current ? `${current}, ${localitate}` : localitate) : current;
            this.ultimaLocalitateInAdresa = localitate || null;
        },

        onLocalitateChanged(e) {
            this.aplicaLocalitateInAdresa(String(e.value || '').trim());
        },

        onCJudetChanged(e) {
            const judetNume = e.component.option('selectedItem')?.Nume;
            if (!judetNume) return;
            let current = (this.newPartnerData.CAdresa || '').trim();
            if (this.ultimulJudetInCAdresa) {
                current = current.replace(this.ultimulJudetInCAdresa, '').replace(/,\s*,/g, ',').replace(/(^,\s*|,\s*$)/g, '').trim();
            }
            this.newPartnerData.CAdresa = current ? `${current}, ${judetNume}` : judetNume;
            this.ultimulJudetInCAdresa = judetNume;
        },

        onCLocalitateChanged(e) {
            const localitate = String(e.value || '').trim();
            let current = (this.newPartnerData.CAdresa || '').trim();
            if (this.ultimaCLocalitateInCAdresa) {
                current = current.replace(this.ultimaCLocalitateInCAdresa, '').replace(/,\s*,/g, ',').replace(/(^,\s*|,\s*$)/g, '').trim();
            }
            this.newPartnerData.CAdresa = localitate ? (current ? `${current}, ${localitate}` : localitate) : current;
            this.ultimaCLocalitateInCAdresa = localitate || null;
        },

        createODataContext() {
            this.fetchEurRate();
            this.dsTari = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_ComercialOdata + 'ERP_Tari',
                    key: 'ID',
                    keyType: "Guid",
                    version: 4,

                    beforeSend: (e: any) => {

                        e.headers = {
                            "Content-Type": "application/json",
                            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")

                        };
                    }
                },
                select: [
                    'ID',
                    'Nume',
                ],

            });

            this.dsLocalitati = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_ComercialOdata + 'ERP_Localitati',
                    key: 'ID',
                    keyType: "Guid",
                    version: 4,

                    beforeSend: (e: any) => {

                        e.headers = {
                            "Content-Type": "application/json",
                            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")

                        };
                    }
                },
                select: [
                    'ID',
                    'Localitate',
                ],

            });
            this.dsGrupuri = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_ComercialOdata + 'PAR_Grupuri',
                    key: 'Id',
                    keyType: "Guid",
                    version: 4,

                    beforeSend: (e: any) => {

                        e.headers = {
                            "Content-Type": "application/json",
                            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")

                        };

                    }
                },
                select: [
                    'Id',
                    'Nume',
                    'Cod'
                ],
                sort: [
                    { selector: 'Cod', desc: false }
                ]

            });

            this.dsPartnerTari = new DataSource({
                store: new ODataStore({
                    url: AppSetting.API_Url_ComercialOdata + 'ERP_Tari', key: 'ID', keyType: 'Guid', version: 4,
                    beforeSend: (e: any) => {
                        e.headers = { 'Content-Type': 'application/json', Authorization: 'Bearer ' + localStorage.getItem('ERA_Jwt') };
                    },
                }),
                select: ['ID', 'Nume'],
                sort: [{ selector: 'Nume', desc: false }],
            });
            this.dsCTari = new DataSource({
                store: new ODataStore({
                    url: AppSetting.API_Url_ComercialOdata + 'ERP_Tari', key: 'ID', keyType: 'Guid', version: 4,
                    beforeSend: (e: any) => {
                        e.headers = { 'Content-Type': 'application/json', Authorization: 'Bearer ' + localStorage.getItem('ERA_Jwt') };
                    },
                }),
                select: ['ID', 'Nume'],
                sort: [{ selector: 'Nume', desc: false }],
            });
            this.dsPartnerJudete = this.buildDsPartnerJudete(this.newPartnerData?.TaraID ?? null);
            this.dsCJudete = this.buildDsPartnerJudete(this.newPartnerData?.CTaraID ?? null);

            this.dsValute = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_ComercialOdata + 'ERP_Valute',
                    key: 'Id',
                    keyType: "Guid",
                    version: 4,

                    beforeSend: (e: any) => {

                        e.headers = {
                            "Content-Type": "application/json",
                            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")

                        };

                    }
                },
                select: [
                    'Id',
                    'Nume',
                ],

            });
            this.dsJudete = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_ComercialOdata + 'ERP_Judete',
                    key: 'ID',
                    keyType: "Guid",
                    version: 4,

                    beforeSend: (e: any) => {

                        e.headers = {
                            "Content-Type": "application/json",
                            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")

                        };
                    }
                },
                select: [
                    'ID',
                    'Nume',
                ],

            });
            this.dsStatus = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_ComercialOdata + 'CRM_StariOportunitati',
                    key: 'ID',
                    keyType: "Guid",
                    version: 4,

                    beforeSend: (e: any) => {

                        e.headers = {
                            "Content-Type": "application/json",
                            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")

                        };

                    }
                },
                select: [
                    'ID',
                    'Nume',
                    'NrOrd',
                    'Pondere'
                ],
                sort: [
                    { selector: 'NrOrd', desc: false }
                ]

            });
            this.dsZona = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_ComercialOdata + 'ERP_Zone',
                    key: 'Id',
                    keyType: "Guid",
                    version: 4,

                    beforeSend: (e: any) => {

                        e.headers = {
                            "Content-Type": "application/json",
                            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")

                        };

                    }
                },
                select: [
                    'Id',
                    'Nume',
                ],

            });
            this.dsBanci = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_ComercialOdata + 'PAR_BanciParteneri',
                    key: 'Id',
                    keyType: "Guid",
                    version: 4,

                    beforeSend: (e: any) => {

                        e.headers = {
                            "Content-Type": "application/json",
                            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")

                        };

                    }
                },
                select: [
                    'Id',
                    'Nume',
                ],

            });
            this.dsParteneriFiscal = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_ComercialOdata + 'PAR_ParteneriFiscal',
                    key: 'ID',
                    keyType: "Guid",
                    version: 4,

                    beforeSend: (e: any) => {

                        e.headers = {
                            "Content-Type": "application/json",
                            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")

                        };
                    }
                },
                select: [
                    'Cod',
                    'Nume',
                ],

            });
            this.dsContacts = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_ComercialOdata + 'CRM_Contacts',
                    key: 'ID',
                    keyType: "Guid",
                    version: 4,
                    fieldTypes: {
                        AccountID: 'Guid'
                    },

                    beforeSend: (e: any) => {

                        e.headers = {
                            "Content-Type": "application/json",
                            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")

                        };
                    }
                },
                select: [
                    'ID',
                    'Nume',
                    'Prenume',
                    'AccountID'
                ],

            });
            this.dsSalesSources = new ODataStore({
                url: AppSetting.API_Url_ComercialOdata + 'CRM_SalesSources',
                key: 'ID',
                version: 4,
                beforeSend: (e) => {
                    e.headers = {
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt"),
                    };
                },
            });
            this.dsProiecte = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_DocumenteOdata + 'DOC_Proiecte',
                    key: 'Id',
                    keyType: "Guid",
                    version: 4,

                    beforeSend: (e: any) => {

                        e.headers = {
                            "Content-Type": "application/json",
                            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")

                        };
                    }
                },
                select: [
                    'Id',
                    'Cod',
                ],

            });
            this.dsSales = new ODataStore({
                url: AppSetting.API_Url_ComercialOdata + 'CRM_Sales',
                key: 'ID',
                keyType: "Guid",
                version: 4,
                beforeSend: (e) => {
                    e.headers = {
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt"),
                    };

                    e.params.$expand = "Account($select=Nume),Contact($select=Nume,Prenume),Campanie($select=Denumire),Valuta($select=Simbol),Sursa($select=Nume),Proiect($select=Cod),Status($select=Nume)";
                    //e.params.$filter = "Owner eq '" + JwtServices.GetUsername() + "'";
                }
            });

            this.dsParteneri = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_ComercialOdata + 'PAR_Parteneri',
                    key: 'ID',
                    keyType: "Guid",
                    version: 4,

                    beforeSend: (e: any) => {

                        e.headers = {
                            "Content-Type": "application/json",
                            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")

                        };
                    }
                },
                select: [
                    'ID',
                    'Nume',
                ],

            });

            this.dsCampaniiMarketing = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_ComercialOdata + 'CRM_CautareCampaniiMarketing',
                    key: 'ID',
                    keyType: "Guid",
                    version: 4,

                    beforeSend: (e: any) => {

                        e.headers = {
                            "Content-Type": "application/json",
                            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")

                        };
                    }
                },
                select: [
                    'ID',
                    'Denumire',
                ],

            });
            this.dsValuta = new ODataStore({
                url: AppSetting.API_Url_ComercialOdata + 'ERP_Valute',
                key: 'Id',
                version: 4,
                beforeSend: (e) => {
                    e.headers = {
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt"),
                    };
                },
            });

        },
        toNullIfEmpty(val) {
            return val === '' || val === undefined || val === null ? null : val;
        },

        normalizeFormData(formData) {
            const cleaned = { ...formData };
            const dateFields = [
                'DataInchidereEstimat',
                'DataInchis',
                'Data',
                'DataCreat',
                'DataModificat'
            ];

            dateFields.forEach((field) => {
                const val = cleaned[field];
                cleaned[field] = this.toNullIfEmpty(val) !== null ? new Date(val) : null;
            });

            Object.keys(cleaned).forEach((key) => {
                cleaned[key] = this.toNullIfEmpty(cleaned[key]);
            });

            return cleaned;
        },

        onPartenerRowClick(e) {

            if (e.data && e.data.ID) {
                const p = e.data;


                this.sPartener = p.ID;
                this.formData.AccountID = p.ID;
                this.contactData.AccountID = p.ID;
                this.formData.Adresa = p.Adresa || '';
                this.formData.TaraID = p.TaraID;
                //this.formData.LocalitateID = p.LocalitateID || '';

                setTimeout(() => {
                    this.isParteneriGridBoxOpened = false;
                }, 150);
            }
        },
        onAddNewPartener() {
            this.newPartnerData = {
                Nume: '',
                CUI: '',
                Cod: '',
                Fiscal: '',
                Client: null,
                Furnizor: null,
                Numar: '',
                Strada: '',
                Localitate: '',
                JudetID: null,
                TaraID: null,
                ZonaID: null,
                Cont: '',
                Banca: '',
                Litigiu: false,
                Extern: false,
                Intern: true,
                Observatii: '',
                AdaosPret: null,
                faraScadenta: false,
                ValutaID: '0A61647E-7391-4087-BC01-8EB9C2CEDEDD',
                Director: '',
                Fax: '',
                Tel: '',
                Email: '',
                www: '',
                GrupID: null,
                CP: '',
                CStrada: '',
                CLocalitate: '',
                CJudetID: null,
                CTaraID: null,
                CCP: '',
                Bloc: '',
                CBloc: '',
                Numarstrada: '',
                Scarabloc: '',
                CNumarstrada: '',
                CScarabloc: '',
                Scadenta: null,
                AgentID: null,
                Angajat: false,
                Memo: '',
                CreditLimita: null,
                DirectorEconomic: '',
                PersoanaContact: '',
                AplicaTVAlaIncasare: false,
                CifraAfacere: null,
                NrAngajati: null,
                Activ: null,
                Owner: '',
                CalculezPenalitati: true,
                ParRecomandareID: null,
                CapitalSocial: null,
                AngajatID: null,
                ExternUE: false,
                StructuraLegaturaID: null,
                PartenerMasterID: null,
                RegimSpecialTVA: false,
                AplicaTvaDefalcat: false,
                Et: '',
                Ap: '',
                Adresa: '',
                CEt: '',
                CAp: '',
                CAdresa: '',
                CalculezPenalitatiDeLa: null,
                Prefix: '',
                Sufix: '',
                Caen: '',
                PunctID: null,
                ParentID: null,
            };
            this.sBanci = null;
            this.showExtendedDetails = false;
            this.newPartnerData.Owner = JwtServices.GetUsername();
            this.newPartnerData.TaraID = 'd31c3594-8d39-4355-9a13-fd699a1b7290'; // Default Country: Romania
            this.newPartnerData.Adresa = 'Romania';
            this.newPartnerData.ValutaID = '0A61647E-7391-4087-BC01-8EB9C2CEDEDD';
            this.newPartnerData.Client = true;
            this.newPartnerData.Furnizor = true;
            this.newPartnerData.Activ = true;
            this.resetIdempotencyKey();
            this.isPartnerModalVisible = true;

            this.dsPartnerJudete = this.buildDsPartnerJudete(this.newPartnerData.TaraID);
            this.dsCJudete = this.buildDsPartnerJudete(null);
            this.ultimulJudetInAdresa = null;
            this.ultimulJudetInCAdresa = null;
            this.ultimaLocalitateInAdresa = null;
            this.ultimaCLocalitateInCAdresa = null;
        },
        onSaveAddContact() {
            const result = this.$refs.form.instance.validate();
            if (!result.isValid) {
                return;
            }

            const nume = this.contactData.Nume?.trim();


            const numeRegex = /^[A-Za-zĂÂÎȘȚăâîșț ]{2,}$/;

            if (!nume) {
                notify('Câmpul "Nume" este obligatoriu!', 'error', 1000);
                return;
            }



            if (!numeRegex.test(nume)) {
                notify(
                    'Câmpul "Nume" trebuie să conțină doar litere și să aibă cel puțin 2 caractere.',
                    'error',
                    2000
                );
                return;
            }

            if (!this.contactData.AccountID && this.sPartener) {
                this.contactData.AccountID = this.sPartener;
            }

            if (!this.contactData.AccountID) {
                notify('Eroare: Contactul trebuie să fie asociat unei companii!', 'error', 2000);
                return;
            }
            const cleanedFormData = { ...this.contactData };
            if (!cleanedFormData.Owner) {
                cleanedFormData.Owner = JwtServices.GetUsername();
            }
            const toNullIfEmpty = (val) => {
                return val === '' || val === undefined ? null : val;
            };
            if (cleanedFormData.DataNasterii) {
                cleanedFormData.DataNasterii = new Date(cleanedFormData.DataNasterii);
            }
            cleanedFormData.Activ = cleanedFormData.Activ ? true : null;
            cleanedFormData.ContactPrimar = cleanedFormData.ContactPrimar ? true : null;
            cleanedFormData.Imagine = toNullIfEmpty(cleanedFormData.Imagine);

            const fieldsToNull = [
                'DataNasterii', 'Activ', 'Imagine',
                'ContactPrimar'
            ];
            fieldsToNull.forEach((field) => {
                cleanedFormData[field] = toNullIfEmpty(cleanedFormData[field]);
            });
            CrmContacts.save(cleanedFormData)
                .then((response) => {
                    notify('Datele au fost salvate cu succes!', 'success', 1000);


                    // Navigate to details
                    const newId = response?.data?.ID || response?.data?.Id || response?.data?.id;


                    this.isContactModalVisible = false; this.contactData = {
                        ID: '',
                        Nume: '',
                        Prenume: '',
                        DataNasterii: null,
                        Sex: '',
                        Titlu: '',
                        AccountID: null,
                        Email: '',
                        TelMunca: '',
                        TelMobil: '',
                        Fax: '',
                        TaraID: null,
                        LocalitateID: null,
                        Adresa: '',
                        MetodaContact: '',
                        Note: '',
                        Activ: true,
                        Owner: '',
                        Imagine: null,
                        ContactPrimar: true
                    };

                    if (newId) {
                        this.dsContacts.reload().then(() => {
                            this.sContact = newId;
                            this.formData.ContactID = newId;
                        });
                    }

                })
                .catch((error) => {
                    notify('Eroare la salvare!', 'error', 1500);
                });
        },
        onSaveAdd() {

            if (!this.formData.Titlu || this.formData.Titlu.trim() === '') {
                notify('Completați câmpul obligatoriu "Denumire Oportunitate"!', 'error', 1000);
                return;
            }

            if (!this.formData.AccountID) {
                notify('Completați câmpul obligatoriu "Partener"!', 'error', 1000);
                return;
            }

            if (!this.formData.ContactID) {
                notify('Completați câmpul obligatoriu "Persoana de contact"!', 'error', 1000);
                return;
            }

            if (!this.formData.SursaID) {
                notify('Completați câmpul obligatoriu "Sursă Lead"!', 'error', 1000);
                return;
            }

            const cleanedFormData = this.normalizeFormData(this.formData);
            const backendFields = [
                'Titlu', 'ContactID', 'AccountID', 'IntervalCumparare',
                'BugetEstimat', 'Note', 'Cerere', 'Oferta', 'DataInchidereEstimat',
                'VenitEstimat', 'Probabilitate', 'Status', 'Owner', 'OwnerID', 'UserCreat',
                'DataCreat', 'UserModificat', 'DataModificat', 'VenitRealizat',
                'DataInchis', 'UltimulStatus', 'MotivInchidere', 'IndustrieID',
                'CampanieID', 'CostEstimat', 'CostEfectiv', 'ListaProduse', 'Cod',
                'Discount', 'ValutaID', 'Curs', 'SursaID', 'Data', 'ProiectID', 'StatusID', 'ProbabilitateCastig'
            ];

            const payload = Object.fromEntries(
                Object.entries(cleanedFormData).filter(([key]) =>
                    backendFields.includes(key)
                )
            );

            CrmSales.save(payload)
                .then((response) => {
                    this.isModalVisible = false;
                    notify('Datele au fost salvate cu succes!', 'success', 1000);

                    // Navigate to details
                    const newId = response?.data?.ID || response?.data?.Id || response?.data?.id;

                    if (newId) {
                        this.$router.push({ path: '/crm/grid-oportunitati', query: { opportunityId: newId } });
                    } else {
                        console.error("New Opportunity ID not found in response", response);
                    }

                    this.formData = {
                        Titlu: '',
                        ContactID: null,
                        AccountID: null,
                        IntervalCumparare: 'Necunoscut',
                        BugetEstimat: null,
                        Note: '',
                        Cerere: '',
                        Oferta: '',
                        DataInchidereEstimat: null,
                        VenitEstimat: null,
                        Probabilitate: 0,
                        Status: null,
                        StatusID: 'BE62B2A3-AEA9-4706-ADED-934622DBEFD9',
                        Owner: '',
                        UserCreat: '',
                        DataCreat: null,
                        UserModificat: '',
                        DataModificat: null,
                        VenitRealizat: null,
                        DataInchis: null,
                        UltimulStatus: '',
                        MotivInchidere: '',
                        IndustrieID: null,
                        CampanieID: null,
                        CostEstimat: null,
                        CostEfectiv: null,
                        ListaProduse: '',
                        Cod: '',
                        Discount: null,
                        ValutaID: null,
                        Curs: null,
                        SursaID: null,
                        Data: null,
                        ProiectID: null,
                        ProbabilitateCastig: null,
                    };

                    this.sStatus = 'BE62B2A3-AEA9-4706-ADED-934622DBEFD9';
                    this.sPartener = null;
                    this.sContact = null;
                    this.createODataContext();
                    this.formData.OwnerID = null;
                })
                .catch((error) => {
                    console.error(error);
                    notify('Eroare la salvare!', 'error', 1500);
                });
        },
        onAddClick() {
            this.formData.Owner = JwtServices.GetUsername();
            this.isModalVisible = true;
            this.formData.ValutaID = '0A61647E-7391-4087-BC01-8EB9C2CEDEDD';
            this.formData.Probabilitate = 0;
            this.formData.Data = new Date();
        },
        onRefreshClick() {
            this.createODataContext();
            notify('Datele au fost actualizate cu succes!', 'success', 1000);
        },
        // Reîncarcă gridul fără notificare — apelat de componenta părinte la revenirea pe tab-ul de listă
        refreshGrid() {
            this.$refs.dataGrid?.instance?.refresh();
        },

        onCancel() {
            this.isModalVisible = false;
            this.$refs.dataGrid?.instance?.cancelEditData();
        },
        onRowRemoving(e: any) {
            // Verificare suplimentară pe server-side: blocăm dacă ownerul nu e utilizatorul logat
            if (e.data?.Owner !== JwtServices.GetUsername()) {
                e.cancel = true;
                notify('Nu aveți permisiunea să ștergeți această oportunitate.', 'error', 3000);
                return;
            }
        },
        onRowRemoved(e: any) {
            notify('Datele au fost șterse cu succes!', 'success', 1000);
            this.$emit('opportunity-deleted', e.key);
        },

        onRowPrepared(e: any) {
            if (e.rowType !== 'data') return;
            const currentUser = JwtServices.GetUsername();
            if (e.data?.Owner !== currentUser) {
                // Ascundem butonul de ștergere pentru rândurile pe care userul nu le deține
                const deleteBtn = e.rowElement.querySelector('.dx-command-edit .dx-link-delete') as HTMLElement | null;
                if (deleteBtn) deleteBtn.style.display = 'none';
            }
        },
        onExporting(e: any) {
            if (e.format === 'pdf') {
                const doc = new jsPDF();
                exportDataGridPdf({
                    jsPDFDocument: doc,
                    component: e.component,
                    indent: 5,
                }).then(() => {
                    doc.save('Oportunități.pdf');
                });
            } else if (e.format === 'xlsx') {

                const workbook = new Workbook();
                const worksheet = workbook.addWorksheet('preturi');

                exportDataGridExcel({
                    component: e.component,
                    worksheet,
                    autoFilterEnabled: true,
                }).then(() => {
                    workbook.xlsx.writeBuffer().then((buffer: any) => {
                        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'Oportunități.xlsx');
                    });
                });
                e.cancel = true;
            }

        },
        setDeleteConfirmationMessage() {
            const dataGrid = this.$refs.dataGrid?.instance;
            dataGrid.option('editing', {
                //allowUpdating: true,
                allowDeleting: true,
                mode: 'popup',
                texts: {
                    confirmDeleteMessage: this.deleteConfirmationMessage,
                    confirmDeleteTitle: "Confirmare Ștergere",
                }
            });
        },
        onRowClick(e) {
            this.$emit('select-opportunity', e.data);
        },

        onRowUpdated(e) {
            this.$emit('opportunity-updated', e.key);
        },

        onOptionChanged(e) {
            // ne interesează DOAR textul din search panel
            if (e.fullName !== "searchPanel.text") return;

            this.searchQuery = e.value || '';
            this.applyGlobalFilter();
        },

        applyGlobalFilter() {
            const grid = this.$refs.dataGrid.instance;
            const filters: any[] = [];

            // 1. Date Filter
            if (this.startDate) {
                const start = new Date(this.startDate);
                start.setHours(0, 0, 0, 0);
                filters.push(["DataCreat", ">=", start]);
            }
            if (this.endDate) {
                if (filters.length > 0) filters.push("and");
                const end = new Date(this.endDate);
                end.setHours(23, 59, 59, 999);
                filters.push(["DataCreat", "<=", end]);
            }

            // 2. Status Filter (Quick Filters)
            if (this.activeFilter === 'negotiation') {
                if (filters.length > 0) filters.push("and");
                filters.push(['Status.Nume', '=', 'Negociere']);
            } else if (this.activeFilter === 'won') {
                if (filters.length > 0) filters.push("and");
                filters.push([
                    ['Status.Nume', '=', 'Castigat'],
                    'or',
                    ['Status.Nume', '=', 'Câștigat'],
                    'or',
                    ['StatusID', '=', '0B2BCD0D-1131-46CC-A4B2-AC685FCCB80E']
                ]);
            }

            // 3. Search Query Filter
            if (this.searchQuery) {
                if (filters.length > 0) filters.push("and");

                const searchFilter = [
                    ["Titlu", "contains", this.searchQuery],
                    "or",
                    ["Contact/Nume", "contains", this.searchQuery],
                    "or",
                    ["Contact/Prenume", "contains", this.searchQuery],
                    "or",
                    ["Account/Nume", "contains", this.searchQuery],
                    "or",
                    ["Status/Nume", "contains", this.searchQuery]
                ];
                filters.push(searchFilter);
            }

            if (filters.length === 0) {
                grid.clearFilter();
            } else {
                grid.filter(filters);
            }
        },

        resetFilters() {
            this.startDate = null;
            this.endDate = null;
            this.activeFilter = 'all';
            const grid = this.$refs.dataGrid.instance;
            grid.clearFilter();
            grid.option("searchPanel.text", "");
            this.searchQuery = "";
        },
        // Normalizare diacritice + case pentru potrivirea numelui de județ primit de la ANAF
        // (ex: "BIHOR") cu nomenclatorul ERP_Judete (ex: "Bihor").
        normalizeazaText(text) {
            return String(text ?? "")
                .normalize("NFD")
                .replace(/[̀-ͯ]/g, "")
                .toUpperCase()
                .trim();
        },
        async cautaJudetDupaNume(nume, taraId) {
            if (!nume || !taraId) return null;
            const store = new ODataStore({
                url: AppSetting.API_Url_ComercialOdata + 'ERP_Judete', key: 'ID', keyType: 'Guid', version: 4,
                fieldTypes: { TaraID: 'Guid' },
                beforeSend: (e) => {
                    e.headers = {
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt"),
                    };
                },
            });
            const rows = await store.load({ filter: ['TaraID', '=', taraId], select: ['ID', 'Nume'] });
            const target = this.normalizeazaText(nume);
            return rows.find(j => this.normalizeazaText(j.Nume) === target) ?? null;
        },
        async onSearchAnaf() {
            const cuiRaw = this.newPartnerData.CUI;
            if (!cuiRaw) {
                notify("Te rog introdu un CUI valid", "warning", 2000);
                return;
            }

            const cui = Number(String(cuiRaw).replace(/\D/g, ""));
            if (!cui) {
                notify("Te rog introdu un CUI valid", "warning", 2000);
                return;
            }

            try {
                // --- 1. APEL DATE GENERALE (Identitate, TVA, Sediu) ---
                const anafResult = await AnafService.getCompanyDetails(cui);

                if (!anafResult) {
                    notify("CUI-ul nu a fost găsit sau nu există date publice.", "warning", 3000);
                    return;
                }

                const dg = anafResult.date_generale;
                const df = anafResult.adresa_domiciliu_fiscal;
                const ss = anafResult.adresa_sediu_social;
                const formaOrg = String(dg?.forma_organizare ?? "").toUpperCase().trim();
                const scpTVA = Boolean(anafResult?.inregistrare_scop_Tva?.scpTVA);

                // Stabilire regim fiscal (F/P/N)
                let fiscal = null;
                if (formaOrg.includes("PERSOANA FIZICA")) {
                    fiscal = "F";
                } else if (formaOrg.includes("PERSOANA JURIDICA")) {
                    fiscal = scpTVA ? "P" : "N";
                }
                if (fiscal) this.newPartnerData.Fiscal = fiscal;

                // Mapare date de bază
                // La fel ca în legacy (PAR_ParteneriForm.cs): CUI cu prefix "RO" doar dacă firma e
                // înregistrată ca plătitor de TVA la data căutării, altfel fără prefix.
                this.newPartnerData.CUI = scpTVA ? `RO${dg.cui}` : String(dg.cui);
                this.newPartnerData.Nume = dg.denumire ?? this.newPartnerData.Nume;
                this.newPartnerData.Numar = dg.nrRegCom ?? this.newPartnerData.Numar;
                this.newPartnerData.Caen = dg.cod_CAEN ?? this.newPartnerData.Caen;
                this.newPartnerData.CAdresa = dg.adresa ?? this.newPartnerData.CAdresa;
                this.newPartnerData.Localitate = ss.sdenumire_Localitate ?? this.newPartnerData.Localitate;
                this.newPartnerData.Strada = ss.sdenumire_Strada ?? this.newPartnerData.Strada;
                this.newPartnerData.Numarstrada = ss.snumar_Strada ?? this.newPartnerData.Numarstrada;
                this.newPartnerData.CP = ss.scod_Postal ?? this.newPartnerData.CP;
                this.newPartnerData.Tel = dg.telefon ?? this.newPartnerData.Tel;

                if (dg.iban) this.newPartnerData.Cont = dg.iban;

                // Logica TVA
                this.newPartnerData.AplicaTVAlaIncasare = anafResult.inregistrare_RTVAI?.statusTvaIncasare ?? false;
                this.newPartnerData.AplicaTvaDefalcat = anafResult.inregistrare_SplitTVA?.statusSplitTVA ?? false;
                if (anafResult.stare_inactiv?.statusInactivi) {
                    this.newPartnerData.Activ = false;
                    notify("Atenție: firma este marcată ca INACTIVĂ la ANAF!", "warning", 4000);
                }

                // Județ Sediu Social — ANAF întoarce doar numele (ex: "BIHOR"), nu ID-ul din
                // nomenclatorul intern ERP_Judete; se caută prin nume normalizat (fără diacritice/case).
                if (!this.newPartnerData.TaraID) {
                    this.newPartnerData.TaraID = "d31c3594-8d39-4355-9a13-fd699a1b7290"; // Romania
                    this.dsPartnerJudete = this.buildDsPartnerJudete(this.newPartnerData.TaraID);
                }
                if (ss?.sdenumire_Judet) {
                    const judet = await this.cautaJudetDupaNume(ss.sdenumire_Judet, this.newPartnerData.TaraID);
                    if (judet) {
                        this.newPartnerData.JudetID = judet.ID;
                        this.aplicaJudetInAdresa(judet.Nume);
                    } else {
                        console.warn(`Județul „${ss.sdenumire_Judet}" (Sediu Social) nu a fost găsit în nomenclator — selectează-l manual.`);
                    }
                }
                if (ss?.sdenumire_Localitate) this.aplicaLocalitateInAdresa(ss.sdenumire_Localitate);
                if (df) {
                    this.newPartnerData.CLocalitate = df.ddenumire_Localitate ?? this.newPartnerData.CLocalitate;
                    this.newPartnerData.CStrada = df.ddenumire_Strada ?? this.newPartnerData.CStrada;
                    this.newPartnerData.CNumarstrada = df.dnumar_Strada ?? this.newPartnerData.CNumarstrada;
                    this.newPartnerData.CCP = df.dcod_Postal ?? this.newPartnerData.CCP;
                    if (df.ddenumire_Judet) {
                        if (!this.newPartnerData.CTaraID) {
                            this.newPartnerData.CTaraID = this.newPartnerData.TaraID;
                            this.dsCJudete = this.buildDsPartnerJudete(this.newPartnerData.CTaraID);
                        }
                        const cJudet = await this.cautaJudetDupaNume(df.ddenumire_Judet, this.newPartnerData.CTaraID);
                        if (cJudet) {
                            this.newPartnerData.CJudetID = cJudet.ID;
                        } else {
                            console.warn(`Județul „${df.ddenumire_Judet}" (Domiciliu Fiscal) nu a fost găsit în nomenclator.`);
                        }
                    }
                }

                const extras = [];
                if (dg.stare_inregistrare) extras.push(`Stare: ${dg.stare_inregistrare}`);
                if (typeof dg.statusRO_e_Factura === "boolean") extras.push(`RO e-Factura: ${dg.statusRO_e_Factura ? "DA" : "NU"}`);

                // --- 2. APEL DATE FINANCIARE (Bilanț pentru CifraAfacere și NumarAngajati) ---
                try {
                    // Încercăm anul 2024, cu fallback pe 2023 dacă nu sunt date depuse încă
                    let finData = await AnafService.getFinancialData(cui, 2024);
                    if (!finData || !finData.i || finData.i.length === 0) {
                        finData = await AnafService.getFinancialData(cui, 2023);
                    }

                    if (finData && finData.i) {
                        const indicatori = finData.i;

                        // 1. Căutăm Cifra de Afaceri
                        const caRow = indicatori.find(item => {
                            const nume = item.val_den_indicator.toUpperCase();
                            return nume.includes("CIFRA DE AFACERI NET") || nume === "VENITURI TOTALE";
                        });

                        // 2. Căutăm Numărul de Angajați
                        const angRow = indicatori.find(item => {
                            const nume = item.val_den_indicator.toUpperCase();
                            return nume.includes("NUMAR MEDIU DE SALARIATI") || nume.includes("NR. MEDIU SALARIATI");
                        });

                        // Populare coloane din par_parteneri
                        if (caRow) {
                            this.newPartnerData.CifraAfacere = caRow.val_indicator;
                            extras.push(`CA: ${caRow.val_indicator.toLocaleString()}`);
                        }

                        if (angRow) {
                            this.newPartnerData.NrAngajati = angRow.val_indicator;
                            extras.push(`Angajați: ${angRow.val_indicator}`);
                        }
                    }
                } catch (finError) {
                    console.warn("Datele financiare nu au putut fi încărcate.", finError);
                    // Nu blocăm execuția dacă firma e nouă sau nu are bilanț
                }

                // Finalizare Memo
                if (extras.length) {
                    const prev = this.newPartnerData.Memo ? String(this.newPartnerData.Memo).trim() + "\n" : "";
                    this.newPartnerData.Memo = prev + extras.join(" | ");
                }

                notify("Datele au fost preluate cu succes!", "success", 2000);

            } catch (error) {
                console.error(error);
                notify("Eroare la interogarea ANAF", "error", 4000);
            }
        }
    },
    mounted() {
        this.fetchEurRate();
        this.fetchStatuses();
        this.createODataContext();
        this.dataGrid = this.$refs.dataGrid as DxDataGrid;
        this.setDeleteConfirmationMessage();
        this.intervalList = [
            { name: 'Necunoscut' },
            { name: 'Imediat' },
            { name: 'Luna aceasta' },
            { name: 'Anul acesta' },
            { name: 'Trimestrul acesta' },
            { name: 'Trimestrul următor' }

        ]

        loadMessages({
            "ro": {
                "Yes": "Da",
                "No": "Nu",
            }
        });

        locale('ro');

        PAR_Parteneri.getDrepturiMele()
            .then((res) => { this.canEditLimiteCredit = res.data?.EditareLimiteCredit === true; })
            .catch(() => { this.canEditLimiteCredit = false; });
    }
});
</script>

<style scoped lang="scss">
// ============================================
// DASHBOARD STATISTICS CARDS
// ============================================

.toolbar-date-filter {
    display: flex;
    align-items: center;
    gap: 8px;
    padding-left: 5px;

    .filter-label {
        font-size: 12px;
        font-weight: 600;
        color: #6b7280;
    }

    :deep(.dx-texteditor) {
        border-radius: 4px;
        background-color: #f9fafb;
    }
}

.dashboard-stats {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 16px;
    margin-bottom: 20px;

    @media (max-width: 1200px) {
        grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: 768px) {
        grid-template-columns: 1fr;
    }
}

/* HEADER POPUP */
.popup-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 18px;
    background: linear-gradient(90deg, #ff2c21, #ff6a4a);
    color: #fff;
}

.popup-header-main {
    display: flex;
    align-items: center;
    gap: 10px;
}

.popup-header-icon {
    font-size: 20px;
}

.popup-header-texts {
    display: flex;
    flex-direction: column;
}

.popup-header-title {
    font-size: 15px;
    font-weight: 700;
}

.popup-header-subtitle {
    font-size: 12px;
    opacity: 0.85;
}

.popup-header-meta {
    display: flex;
    align-items: center;
}


/* Status Chips */
.status-chip {
    padding: 6px 14px;
    border-radius: 20px;
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    background: rgba(255, 255, 255, 0.2);
    color: white;
    border: 1px solid rgba(255, 255, 255, 0.3);

    &--open {
        background: #e0f2fe;
        color: #0369a1;
        border-color: #bae6fd;
    }

    &--won {
        background: #dcfce7;
        color: #15803d;
        border-color: #bbf7d0;
    }

    &--lost {
        background: #fee2e2;
        color: #b91c1c;
        border-color: #fecaca;
    }
}

.status-chip--draft {
    background-color: rgba(255, 255, 255, 0.18);
}



/* TAB PROGRESS (mini wizard deasupra taburilor) */
.tabs-progress {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
}

.tabs-progress-item {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 4px 10px;
    border-radius: 999px;
    font-size: 11px;
    background-color: #ececf5;
    color: #555;
    cursor: default;
}

.tabs-progress-item--active {
    background-color: #ff2c21;
    color: #fff;
}

.tabs-progress-item .step-index {
    display: inline-flex;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    font-size: 10px;
    background-color: rgba(255, 255, 255, 0.2);
}

/* FORM SECTIONS */
.form-section-card {
    background-color: #fff;
    border-radius: 10px;
    padding: 14px 16px !important;
    box-shadow: 0 2px 8px rgba(15, 23, 42, 0.08);
    margin-bottom: 12px;
}


:deep(.show-more-btn .dx-button-text) {
    white-space: normal !important;
}

:deep(.show-more-btn .dx-button-content) {
    white-space: normal !important;
    flex-wrap: wrap;
    /* important când ai icon + text */
}

:deep(.show-more-btn) {
    height: 25px;
    width: 400px;
    /* lasă butonul să crească pe verticală */
}

.form-section-card .dx-field-item-label-text {
    font-weight: 600;
}

.form-section-compact .dx-field-item {
    margin-bottom: 4px;
}

/* TAB STRIP DEVEXTREME */
/* icon + text pe același rând în tab-uri */
.modern-tabs .dx-tab {
    display: flex;
    align-items: center;
    gap: 1px;
    /* spațiu mic între icon și text */
}

.modern-tabs .dx-tab .dx-icon {
    margin: 0;
    font-size: 14px;
}


.modern-tabs .dx-tab.dx-tab-selected {
    background-color: #ff2c21;
    color: #fff;
}

.modern-tabs .dx-tab:hover {
    background-color: rgba(255, 44, 33, 0.08);
}

/* FOOTER */
.footer-modern {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 18px;
    border-top: 1px solid #e2e2ed;
    background-color: #fff;
}

.footer-hint {
    font-size: 11px;
    color: #888;
}

.footer-right .dx-button {
    margin-left: 8px;
}


.stat-card {
    background: white;
    border-radius: 8px;
    padding: 20px;
    display: flex;
    align-items: center;
    gap: 16px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    transition: all 0.2s ease;
    cursor: pointer;
    user-select: none;

    &:hover {
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.15);
        transform: translateY(-2px);
    }

    .stat-icon {
        width: 48px;
        height: 48px;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;

        i {
            font-size: 24px;
        }
    }

    .stat-content {
        flex: 1;

        .stat-label {
            font-size: 13px;
            color: #6b7280;
            margin-bottom: 4px;
        }

        .stat-value {
            font-size: 24px;
            font-weight: 600;
            color: #111827;
        }
    }
}

// ============================================
// ============================================
// POPUP STYLING - SIMPLE APP STYLE
// ============================================

.popup-body-simple {

    padding: 20px;
}

// Form Section Simple
:deep(.form-section-simple) {
    .dx-form-group-caption {
        background: #f8f9fa;
        color: #333;
        font-size: 14px;
        font-weight: 600;
        padding: 10px 15px;
        margin: 15px 0 10px 0;
        border-left: 3px solid #ff2c21;
        border-radius: 0;
    }

    .dx-form-group-content {
        background: white;
        padding: 15px 0;
        margin-bottom: 10px;
    }
}

.form-footer {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    margin-top: 2px;
}

// Form Fields
:deep(.dx-field-item) {
    margin-bottom: 15px;

    .dx-field-item-label-text {
        font-weight: 500;
        color: #333;
        font-size: 13px;
        margin-bottom: 5px;
    }

    .dx-texteditor,
    .dx-dropdownbox,
    .dx-selectbox {
        border-radius: 4px;
        border-color: #ddd;

        &:hover {
            border-color: #bbb;
        }

        &.dx-state-focused {
            border-color: #ff2c21;
        }
    }

    .dx-texteditor-input {
        padding: 8px 10px;
        font-size: 13px;
    }
}

// Footer Buttons - Simple Style
:deep(.popup-footer-professional) {
    background: white;
    padding: 15px 20px;
    border-top: 1px solid #ddd;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin-top: 20px;

    .dx-button {
        border-radius: 4px;
        font-weight: normal;
        padding: 8px 16px;
        min-width: 100px;
        font-size: 13px;
    }
}

// Scroll View
:deep(.dx-scrollview-content) {
    padding: 0;
}

.crm-opportunities-container {
    background: #f8f9fa;
    padding: 16px;
    border-radius: 8px;
}

// Status Badges
.status-cell {
    display: flex;
    align-items: center;
}

.status-badge {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 4px 12px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 500;

    .status-dot {
        width: 6px;
        height: 6px;
        border-radius: 50%;
    }
}

.status-won {
    background: #d1fae5;
    color: #065f46;

    .status-dot {
        background: #065f46;
    }
}

.status-closed {
    background: #fee2e2;
    color: #991b1b;

    .status-dot {
        background: #991b1b;
    }
}

.status-new {
    background: #dbeafe;
    color: #1e40af;

    .status-dot {
        background: #1e40af;
    }
}

.status-negotiation {
    background: #fed7aa;
    color: #92400e;

    .status-dot {
        background: #92400e;
    }
}

.status-identificat {
    background: #f3f4f6;
    color: #4b5563;

    .status-dot {
        background: #4b5563;
    }
}

.status-calificare {
    background: #cffafe;
    color: #0e7490;

    .status-dot {
        background: #0e7490;
    }
}

.status-demo {
    background: #ede9fe;
    color: #7c3aed;

    .status-dot {
        background: #7c3aed;
    }
}

.status-offer {
    background: #fef3c7;
    color: #b45309;

    .status-dot {
        background: #b45309;
    }
}


// Title, Contact, Company cells with icons
.title-cell,
.contact-cell,
.company-cell {
    display: flex;
    align-items: center;
    gap: 8px;

    i {
        color: #6b7280;
        font-size: 16px;
    }

    .title-text {
        font-weight: 500;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
}

// Currency cells
.currency-cell {
    .currency-value {
        font-weight: 500;
        color: #059669;
    }

    &.revenue .currency-value {
        color: #0891b2;
    }
}

// Probability cell with progress bar
.probability-cell {
    display: flex;
    align-items: center;
    gap: 8px;

    .probability-bar {
        flex: 1;
        height: 6px;
        background: #e5e7eb;
        border-radius: 3px;
        overflow: hidden;

        .probability-fill {
            height: 100%;
            transition: width 0.3s ease;
            border-radius: 3px;
        }
    }

    .probability-text {
        font-size: 12px;
        font-weight: 500;
        color: #374151;
        min-width: 35px;
    }
}

.date-cell {
    display: flex;
    align-items: center;
    gap: 6px;
}

.date-cell i {
    font-size: 15px;
    color: #6b6f76;
    opacity: 0.85;
}


.date-empty {
    color: #999;
}

// Quick Filter Buttons
.filter-buttons {
    display: flex;
    gap: 8px;
    align-items: center;

    .dx-button {
        font-size: 13px;
        padding: 6px 14px;
        border-radius: 4px;
        transition: all 0.2s ease;
    }
}

// Toolbar separator
.separator {
    width: 1px;
    height: 24px;
    background: #e5e7eb;
    margin: 0 8px;
}

.owner-cell {
    display: flex;
    align-items: center;
    gap: 6px;
}

.owner-cell i {
    font-size: 16px;
    color: #6b6f76;
    opacity: 0.85;
}

.popup-body-simple {
    display: flex;
    flex-direction: column;
    height: 100%;
}

.form-content {
    flex: 1;
    overflow-y: auto;
    padding-bottom: 10px;
    /* spațiu pentru footer */
}

.footer-fixed {
    position: sticky;
    bottom: 0;
    padding: 10px 16px;
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    z-index: 10;
}
</style>
